
!function (e, t) { "object" == typeof exports && "undefined" != typeof module ? module.exports = t() : "function" == typeof define && define.amd ? define(t) : (e = "undefined" != typeof globalThis ? globalThis : e || self).axios = t() }(this, (function () { "use strict"; function e(t) { return e = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) { return typeof e } : function (e) { return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e }, e(t) } function t(e, t) { if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function") } function n(e, t) { for (var n = 0; n < t.length; n++) { var r = t[n]; r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r) } } function r(e, t, r) { return t && n(e.prototype, t), r && n(e, r), Object.defineProperty(e, "prototype", { writable: !1 }), e } function o(e, t) { return function () { return e.apply(t, arguments) } } var i, s = Object.prototype.toString, a = Object.getPrototypeOf, u = (i = Object.create(null), function (e) { var t = s.call(e); return i[t] || (i[t] = t.slice(8, -1).toLowerCase()) }), c = function (e) { return e = e.toLowerCase(), function (t) { return u(t) === e } }, f = function (t) { return function (n) { return e(n) === t } }, l = Array.isArray, d = f("undefined"); var h = c("ArrayBuffer"); var p = f("string"), m = f("function"), v = f("number"), y = function (t) { return null !== t && "object" === e(t) }, b = function (e) { if ("object" !== u(e)) return !1; var t = a(e); return !(null !== t && t !== Object.prototype && null !== Object.getPrototypeOf(t) || Symbol.toStringTag in e || Symbol.iterator in e) }, g = c("Date"), E = c("File"), w = c("Blob"), O = c("FileList"), R = c("URLSearchParams"); function S(t, n) { var r, o, i = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {}, s = i.allOwnKeys, a = void 0 !== s && s; if (null != t) if ("object" !== e(t) && (t = [t]), l(t)) for (r = 0, o = t.length; r < o; r++)n.call(null, t[r], r, t); else { var u, c = a ? Object.getOwnPropertyNames(t) : Object.keys(t), f = c.length; for (r = 0; r < f; r++)u = c[r], n.call(null, t[u], u, t) } } var A, j = (A = "undefined" != typeof Uint8Array && a(Uint8Array), function (e) { return A && e instanceof A }), T = c("HTMLFormElement"), x = function (e) { var t = Object.prototype.hasOwnProperty; return function (e, n) { return t.call(e, n) } }(), C = c("RegExp"), N = function (e, t) { var n = Object.getOwnPropertyDescriptors(e), r = {}; S(n, (function (n, o) { !1 !== t(n, o, e) && (r[o] = n) })), Object.defineProperties(e, r) }, P = { isArray: l, isArrayBuffer: h, isBuffer: function (e) { return null !== e && !d(e) && null !== e.constructor && !d(e.constructor) && m(e.constructor.isBuffer) && e.constructor.isBuffer(e) }, isFormData: function (e) { var t = "[object FormData]"; return e && ("function" == typeof FormData && e instanceof FormData || s.call(e) === t || m(e.toString) && e.toString() === t) }, isArrayBufferView: function (e) { return "undefined" != typeof ArrayBuffer && ArrayBuffer.isView ? ArrayBuffer.isView(e) : e && e.buffer && h(e.buffer) }, isString: p, isNumber: v, isBoolean: function (e) { return !0 === e || !1 === e }, isObject: y, isPlainObject: b, isUndefined: d, isDate: g, isFile: E, isBlob: w, isRegExp: C, isFunction: m, isStream: function (e) { return y(e) && m(e.pipe) }, isURLSearchParams: R, isTypedArray: j, isFileList: O, forEach: S, merge: function e() { for (var t = {}, n = function (n, r) { b(t[r]) && b(n) ? t[r] = e(t[r], n) : b(n) ? t[r] = e({}, n) : l(n) ? t[r] = n.slice() : t[r] = n }, r = 0, o = arguments.length; r < o; r++)arguments[r] && S(arguments[r], n); return t }, extend: function (e, t, n) { var r = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : {}, i = r.allOwnKeys; return S(t, (function (t, r) { n && m(t) ? e[r] = o(t, n) : e[r] = t }), { allOwnKeys: i }), e }, trim: function (e) { return e.trim ? e.trim() : e.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, "") }, stripBOM: function (e) { return 65279 === e.charCodeAt(0) && (e = e.slice(1)), e }, inherits: function (e, t, n, r) { e.prototype = Object.create(t.prototype, r), e.prototype.constructor = e, Object.defineProperty(e, "super", { value: t.prototype }), n && Object.assign(e.prototype, n) }, toFlatObject: function (e, t, n, r) { var o, i, s, u = {}; if (t = t || {}, null == e) return t; do { for (i = (o = Object.getOwnPropertyNames(e)).length; i-- > 0;)s = o[i], r && !r(s, e, t) || u[s] || (t[s] = e[s], u[s] = !0); e = !1 !== n && a(e) } while (e && (!n || n(e, t)) && e !== Object.prototype); return t }, kindOf: u, kindOfTest: c, endsWith: function (e, t, n) { e = String(e), (void 0 === n || n > e.length) && (n = e.length), n -= t.length; var r = e.indexOf(t, n); return -1 !== r && r === n }, toArray: function (e) { if (!e) return null; if (l(e)) return e; var t = e.length; if (!v(t)) return null; for (var n = new Array(t); t-- > 0;)n[t] = e[t]; return n }, forEachEntry: function (e, t) { for (var n, r = (e && e[Symbol.iterator]).call(e); (n = r.next()) && !n.done;) { var o = n.value; t.call(e, o[0], o[1]) } }, matchAll: function (e, t) { for (var n, r = []; null !== (n = e.exec(t));)r.push(n); return r }, isHTMLForm: T, hasOwnProperty: x, hasOwnProp: x, reduceDescriptors: N, freezeMethods: function (e) { N(e, (function (t, n) { var r = e[n]; m(r) && (t.enumerable = !1, "writable" in t ? t.writable = !1 : t.set || (t.set = function () { throw Error("Can not read-only method '" + n + "'") })) })) }, toObjectSet: function (e, t) { var n = {}, r = function (e) { e.forEach((function (e) { n[e] = !0 })) }; return l(e) ? r(e) : r(String(e).split(t)), n }, toCamelCase: function (e) { return e.toLowerCase().replace(/[_-\s]([a-z\d])(\w*)/g, (function (e, t, n) { return t.toUpperCase() + n })) }, noop: function () { }, toFiniteNumber: function (e, t) { return e = +e, Number.isFinite(e) ? e : t } }; function _(e, t, n, r, o) { Error.call(this), Error.captureStackTrace ? Error.captureStackTrace(this, this.constructor) : this.stack = (new Error).stack, this.message = e, this.name = "AxiosError", t && (this.code = t), n && (this.config = n), r && (this.request = r), o && (this.response = o) } P.inherits(_, Error, { toJSON: function () { return { message: this.message, name: this.name, description: this.description, number: this.number, fileName: this.fileName, lineNumber: this.lineNumber, columnNumber: this.columnNumber, stack: this.stack, config: this.config, code: this.code, status: this.response && this.response.status ? this.response.status : null } } }); var B = _.prototype, D = {};["ERR_BAD_OPTION_VALUE", "ERR_BAD_OPTION", "ECONNABORTED", "ETIMEDOUT", "ERR_NETWORK", "ERR_FR_TOO_MANY_REDIRECTS", "ERR_DEPRECATED", "ERR_BAD_RESPONSE", "ERR_BAD_REQUEST", "ERR_CANCELED", "ERR_NOT_SUPPORT", "ERR_INVALID_URL"].forEach((function (e) { D[e] = { value: e } })), Object.defineProperties(_, D), Object.defineProperty(B, "isAxiosError", { value: !0 }), _.from = function (e, t, n, r, o, i) { var s = Object.create(B); return P.toFlatObject(e, s, (function (e) { return e !== Error.prototype }), (function (e) { return "isAxiosError" !== e })), _.call(s, e.message, t, n, r, o), s.cause = e, s.name = e.name, i && Object.assign(s, i), s }; var F = "object" == ("undefined" == typeof self ? "undefined" : e(self)) ? self.FormData : window.FormData; function U(e) { return P.isPlainObject(e) || P.isArray(e) } function k(e) { return P.endsWith(e, "[]") ? e.slice(0, -2) : e } function L(e, t, n) { return e ? e.concat(t).map((function (e, t) { return e = k(e), !n && t ? "[" + e + "]" : e })).join(n ? "." : "") : t } var q = P.toFlatObject(P, {}, null, (function (e) { return /^is[A-Z]/.test(e) })); function z(t, n, r) { if (!P.isObject(t)) throw new TypeError("target must be an object"); n = n || new (F || FormData); var o, i = (r = P.toFlatObject(r, { metaTokens: !0, dots: !1, indexes: !1 }, !1, (function (e, t) { return !P.isUndefined(t[e]) }))).metaTokens, s = r.visitor || l, a = r.dots, u = r.indexes, c = (r.Blob || "undefined" != typeof Blob && Blob) && ((o = n) && P.isFunction(o.append) && "FormData" === o[Symbol.toStringTag] && o[Symbol.iterator]); if (!P.isFunction(s)) throw new TypeError("visitor must be a function"); function f(e) { if (null === e) return ""; if (P.isDate(e)) return e.toISOString(); if (!c && P.isBlob(e)) throw new _("Blob is not supported. Use a Buffer instead."); return P.isArrayBuffer(e) || P.isTypedArray(e) ? c && "function" == typeof Blob ? new Blob([e]) : Buffer.from(e) : e } function l(t, r, o) { var s = t; if (t && !o && "object" === e(t)) if (P.endsWith(r, "{}")) r = i ? r : r.slice(0, -2), t = JSON.stringify(t); else if (P.isArray(t) && function (e) { return P.isArray(e) && !e.some(U) }(t) || P.isFileList(t) || P.endsWith(r, "[]") && (s = P.toArray(t))) return r = k(r), s.forEach((function (e, t) { !P.isUndefined(e) && n.append(!0 === u ? L([r], t, a) : null === u ? r : r + "[]", f(e)) })), !1; return !!U(t) || (n.append(L(o, r, a), f(t)), !1) } var d = [], h = Object.assign(q, { defaultVisitor: l, convertValue: f, isVisitable: U }); if (!P.isObject(t)) throw new TypeError("data must be an object"); return function e(t, r) { if (!P.isUndefined(t)) { if (-1 !== d.indexOf(t)) throw Error("Circular reference detected in " + r.join(".")); d.push(t), P.forEach(t, (function (t, o) { !0 === (!P.isUndefined(t) && s.call(n, t, P.isString(o) ? o.trim() : o, r, h)) && e(t, r ? r.concat(o) : [o]) })), d.pop() } }(t), n } function I(e) { var t = { "!": "%21", "'": "%27", "(": "%28", ")": "%29", "~": "%7E", "%20": "+", "%00": "\0" }; return encodeURIComponent(e).replace(/[!'()~]|%20|%00/g, (function (e) { return t[e] })) } function M(e, t) { this._pairs = [], e && z(e, this, t) } var J = M.prototype; function H(e) { return encodeURIComponent(e).replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+").replace(/%5B/gi, "[").replace(/%5D/gi, "]") } function V(e, t, n) { if (!t) return e; var r = e.indexOf("#"); -1 !== r && (e = e.slice(0, r)); var o = n && n.encode || H, i = P.isURLSearchParams(t) ? t.toString() : new M(t, n).toString(o); return i && (e += (-1 === e.indexOf("?") ? "?" : "&") + i), e } J.append = function (e, t) { this._pairs.push([e, t]) }, J.toString = function (e) { var t = e ? function (t) { return e.call(this, t, I) } : I; return this._pairs.map((function (e) { return t(e[0]) + "=" + t(e[1]) }), "").join("&") }; var W, K = function () { function e() { t(this, e), this.handlers = [] } return r(e, [{ key: "use", value: function (e, t, n) { return this.handlers.push({ fulfilled: e, rejected: t, synchronous: !!n && n.synchronous, runWhen: n ? n.runWhen : null }), this.handlers.length - 1 } }, { key: "eject", value: function (e) { this.handlers[e] && (this.handlers[e] = null) } }, { key: "clear", value: function () { this.handlers && (this.handlers = []) } }, { key: "forEach", value: function (e) { P.forEach(this.handlers, (function (t) { null !== t && e(t) })) } }]), e }(), X = { silentJSONParsing: !0, forcedJSONParsing: !0, clarifyTimeoutError: !1 }, $ = "undefined" != typeof URLSearchParams ? URLSearchParams : M, Q = FormData, G = ("undefined" == typeof navigator || "ReactNative" !== (W = navigator.product) && "NativeScript" !== W && "NS" !== W) && "undefined" != typeof window && "undefined" != typeof document, Y = { isBrowser: !0, classes: { URLSearchParams: $, FormData: Q, Blob: Blob }, isStandardBrowserEnv: G, protocols: ["http", "https", "file", "blob", "url", "data"] }; function Z(e) { function t(e, n, r, o) { var i = e[o++], s = Number.isFinite(+i), a = o >= e.length; return i = !i && P.isArray(r) ? r.length : i, a ? (P.hasOwnProp(r, i) ? r[i] = [r[i], n] : r[i] = n, !s) : (r[i] && P.isObject(r[i]) || (r[i] = []), t(e, n, r[i], o) && P.isArray(r[i]) && (r[i] = function (e) { var t, n, r = {}, o = Object.keys(e), i = o.length; for (t = 0; t < i; t++)r[n = o[t]] = e[n]; return r }(r[i])), !s) } if (P.isFormData(e) && P.isFunction(e.entries)) { var n = {}; return P.forEachEntry(e, (function (e, r) { t(function (e) { return P.matchAll(/\w+|\[(\w*)]/g, e).map((function (e) { return "[]" === e[0] ? "" : e[1] || e[0] })) }(e), r, n, 0) })), n } return null } var ee = Y.isStandardBrowserEnv ? { write: function (e, t, n, r, o, i) { var s = []; s.push(e + "=" + encodeURIComponent(t)), P.isNumber(n) && s.push("expires=" + new Date(n).toGMTString()), P.isString(r) && s.push("path=" + r), P.isString(o) && s.push("domain=" + o), !0 === i && s.push("secure"), document.cookie = s.join("; ") }, read: function (e) { var t = document.cookie.match(new RegExp("(^|;\\s*)(" + e + ")=([^;]*)")); return t ? decodeURIComponent(t[3]) : null }, remove: function (e) { this.write(e, "", Date.now() - 864e5) } } : { write: function () { }, read: function () { return null }, remove: function () { } }; function te(e, t) { return e && !/^([a-z][a-z\d+\-.]*:)?\/\//i.test(t) ? function (e, t) { return t ? e.replace(/\/+$/, "") + "/" + t.replace(/^\/+/, "") : e }(e, t) : t } var ne = Y.isStandardBrowserEnv ? function () { var e, t = /(msie|trident)/i.test(navigator.userAgent), n = document.createElement("a"); function r(e) { var r = e; return t && (n.setAttribute("href", r), r = n.href), n.setAttribute("href", r), { href: n.href, protocol: n.protocol ? n.protocol.replace(/:$/, "") : "", host: n.host, search: n.search ? n.search.replace(/^\?/, "") : "", hash: n.hash ? n.hash.replace(/^#/, "") : "", hostname: n.hostname, port: n.port, pathname: "/" === n.pathname.charAt(0) ? n.pathname : "/" + n.pathname } } return e = r(window.location.href), function (t) { var n = P.isString(t) ? r(t) : t; return n.protocol === e.protocol && n.host === e.host } }() : function () { return !0 }; function re(e, t, n) { _.call(this, null == e ? "canceled" : e, _.ERR_CANCELED, t, n), this.name = "CanceledError" } P.inherits(re, _, { __CANCEL__: !0 }); var oe = P.toObjectSet(["age", "authorization", "content-length", "content-type", "etag", "expires", "from", "host", "if-modified-since", "if-unmodified-since", "last-modified", "location", "max-forwards", "proxy-authorization", "referer", "retry-after", "user-agent"]), ie = Symbol("internals"), se = Symbol("defaults"); function ae(e) { return e && String(e).trim().toLowerCase() } function ue(e) { return !1 === e || null == e ? e : String(e) } function ce(e, t, n, r) { return P.isFunction(r) ? r.call(this, t, n) : P.isString(t) ? P.isString(r) ? -1 !== t.indexOf(r) : P.isRegExp(r) ? r.test(t) : void 0 : void 0 } function fe(e, t) { t = t.toLowerCase(); for (var n, r = Object.keys(e), o = r.length; o-- > 0;)if (t === (n = r[o]).toLowerCase()) return n; return null } function le(e, t) { e && this.set(e), this[se] = t || null } function de(e, t) { var n = 0, r = function (e, t) { e = e || 10; var n, r = new Array(e), o = new Array(e), i = 0, s = 0; return t = void 0 !== t ? t : 1e3, function (a) { var u = Date.now(), c = o[s]; n || (n = u), r[i] = a, o[i] = u; for (var f = s, l = 0; f !== i;)l += r[f++], f %= e; if ((i = (i + 1) % e) === s && (s = (s + 1) % e), !(u - n < t)) { var d = c && u - c; return d ? Math.round(1e3 * l / d) : void 0 } } }(50, 250); return function (o) { var i = o.loaded, s = o.lengthComputable ? o.total : void 0, a = i - n, u = r(a); n = i; var c = { loaded: i, total: s, progress: s ? i / s : void 0, bytes: a, rate: u || void 0, estimated: u && s && i <= s ? (s - i) / u : void 0 }; c[t ? "download" : "upload"] = !0, e(c) } } function he(e) { return new Promise((function (t, n) { var r, o = e.data, i = le.from(e.headers).normalize(), s = e.responseType; function a() { e.cancelToken && e.cancelToken.unsubscribe(r), e.signal && e.signal.removeEventListener("abort", r) } P.isFormData(o) && Y.isStandardBrowserEnv && i.setContentType(!1); var u = new XMLHttpRequest; if (e.auth) { var c = e.auth.username || "", f = e.auth.password ? unescape(encodeURIComponent(e.auth.password)) : ""; i.set("Authorization", "Basic " + btoa(c + ":" + f)) } var l = te(e.baseURL, e.url); function d() { if (u) { var r = le.from("getAllResponseHeaders" in u && u.getAllResponseHeaders()); !function (e, t, n) { var r = n.config.validateStatus; n.status && r && !r(n.status) ? t(new _("Request failed with status code " + n.status, [_.ERR_BAD_REQUEST, _.ERR_BAD_RESPONSE][Math.floor(n.status / 100) - 4], n.config, n.request, n)) : e(n) }((function (e) { t(e), a() }), (function (e) { n(e), a() }), { data: s && "text" !== s && "json" !== s ? u.response : u.responseText, status: u.status, statusText: u.statusText, headers: r, config: e, request: u }), u = null } } if (u.open(e.method.toUpperCase(), V(l, e.params, e.paramsSerializer), !0), u.timeout = e.timeout, "onloadend" in u ? u.onloadend = d : u.onreadystatechange = function () { u && 4 === u.readyState && (0 !== u.status || u.responseURL && 0 === u.responseURL.indexOf("file:")) && setTimeout(d) }, u.onabort = function () { u && (n(new _("Request aborted", _.ECONNABORTED, e, u)), u = null) }, u.onerror = function () { n(new _("Network Error", _.ERR_NETWORK, e, u)), u = null }, u.ontimeout = function () { var t = e.timeout ? "timeout of " + e.timeout + "ms exceeded" : "timeout exceeded", r = e.transitional || X; e.timeoutErrorMessage && (t = e.timeoutErrorMessage), n(new _(t, r.clarifyTimeoutError ? _.ETIMEDOUT : _.ECONNABORTED, e, u)), u = null }, Y.isStandardBrowserEnv) { var h = (e.withCredentials || ne(l)) && e.xsrfCookieName && ee.read(e.xsrfCookieName); h && i.set(e.xsrfHeaderName, h) } void 0 === o && i.setContentType(null), "setRequestHeader" in u && P.forEach(i.toJSON(), (function (e, t) { u.setRequestHeader(t, e) })), P.isUndefined(e.withCredentials) || (u.withCredentials = !!e.withCredentials), s && "json" !== s && (u.responseType = e.responseType), "function" == typeof e.onDownloadProgress && u.addEventListener("progress", de(e.onDownloadProgress, !0)), "function" == typeof e.onUploadProgress && u.upload && u.upload.addEventListener("progress", de(e.onUploadProgress)), (e.cancelToken || e.signal) && (r = function (t) { u && (n(!t || t.type ? new re(null, e, u) : t), u.abort(), u = null) }, e.cancelToken && e.cancelToken.subscribe(r), e.signal && (e.signal.aborted ? r() : e.signal.addEventListener("abort", r))); var p, m = (p = /^([-+\w]{1,25})(:?\/\/|:)/.exec(l)) && p[1] || ""; m && -1 === Y.protocols.indexOf(m) ? n(new _("Unsupported protocol " + m + ":", _.ERR_BAD_REQUEST, e)) : u.send(o || null) })) } Object.assign(le.prototype, { set: function (e, t, n) { var r = this; function o(e, t, n) { var o = ae(t); if (!o) throw new Error("header name must be a non-empty string"); var i = fe(r, o); (!i || !0 === n || !1 !== r[i] && !1 !== n) && (e = P.isArray(e) ? e.map(ue) : ue(e), r[i || t] = e) } return P.isPlainObject(e) ? P.forEach(e, (function (e, n) { o(e, n, t) })) : o(t, e, n), this }, get: function (e, t) { if (e = ae(e)) { var n = fe(this, e); if (n) { var r = this[n]; if (!t) return r; if (!0 === t) return function (e) { for (var t, n = Object.create(null), r = /([^\s,;=]+)\s*(?:=\s*([^,;]+))?/g; t = r.exec(e);)n[t[1]] = t[2]; return n }(r); if (P.isFunction(t)) return t.call(this, r, n); if (P.isRegExp(t)) return t.exec(r); throw new TypeError("parser must be boolean|regexp|function") } } }, has: function (e, t) { if (e = ae(e)) { var n = fe(this, e); return !(!n || t && !ce(0, this[n], n, t)) } return !1 }, delete: function (e, t) { var n = this, r = !1; function o(e) { if (e = ae(e)) { var o = fe(n, e); !o || t && !ce(0, n[o], o, t) || (delete n[o], r = !0) } } return P.isArray(e) ? e.forEach(o) : o(e), r }, clear: function () { return Object.keys(this).forEach(this.delete.bind(this)) }, normalize: function (e) { var t = this, n = {}; return P.forEach(this, (function (r, o) { var i = fe(n, o); if (i) return t[i] = ue(r), void delete t[o]; var s = e ? function (e) { return e.trim().toLowerCase().replace(/([a-z\d])(\w*)/g, (function (e, t, n) { return t.toUpperCase() + n })) }(o) : String(o).trim(); s !== o && delete t[o], t[s] = ue(r), n[s] = !0 })), this }, toJSON: function () { var e = Object.create(null); return P.forEach(Object.assign({}, this[se] || null, this), (function (t, n) { null != t && !1 !== t && (e[n] = P.isArray(t) ? t.join(", ") : t) })), e } }), Object.assign(le, { from: function (e) { return P.isString(e) ? new this((i = {}, (t = e) && t.split("\n").forEach((function (e) { o = e.indexOf(":"), n = e.substring(0, o).trim().toLowerCase(), r = e.substring(o + 1).trim(), !n || i[n] && oe[n] || ("set-cookie" === n ? i[n] ? i[n].push(r) : i[n] = [r] : i[n] = i[n] ? i[n] + ", " + r : r) })), i)) : e instanceof this ? e : new this(e); var t, n, r, o, i }, accessor: function (e) { var t = (this[ie] = this[ie] = { accessors: {} }).accessors, n = this.prototype; function r(e) { var r = ae(e); t[r] || (!function (e, t) { var n = P.toCamelCase(" " + t);["get", "set", "has"].forEach((function (r) { Object.defineProperty(e, r + n, { value: function (e, n, o) { return this[r].call(this, t, e, n, o) }, configurable: !0 }) })) }(n, e), t[r] = !0) } return P.isArray(e) ? e.forEach(r) : r(e), this } }), le.accessor(["Content-Type", "Content-Length", "Accept", "Accept-Encoding", "User-Agent"]), P.freezeMethods(le.prototype), P.freezeMethods(le); var pe = { http: he, xhr: he }, me = function (e) { if (P.isString(e)) { var t = pe[e]; if (!e) throw Error(P.hasOwnProp(e) ? "Adapter '".concat(e, "' is not available in the build") : "Can not resolve adapter '".concat(e, "'")); return t } if (!P.isFunction(e)) throw new TypeError("adapter is not a function"); return e }, ve = { "Content-Type": "application/x-www-form-urlencoded" }; var ye, be = { transitional: X, adapter: ("undefined" != typeof XMLHttpRequest ? ye = me("xhr") : "undefined" != typeof process && "process" === P.kindOf(process) && (ye = me("http")), ye), transformRequest: [function (e, t) { var n, r = t.getContentType() || "", o = r.indexOf("application/json") > -1, i = P.isObject(e); if (i && P.isHTMLForm(e) && (e = new FormData(e)), P.isFormData(e)) return o && o ? JSON.stringify(Z(e)) : e; if (P.isArrayBuffer(e) || P.isBuffer(e) || P.isStream(e) || P.isFile(e) || P.isBlob(e)) return e; if (P.isArrayBufferView(e)) return e.buffer; if (P.isURLSearchParams(e)) return t.setContentType("application/x-www-form-urlencoded;charset=utf-8", !1), e.toString(); if (i) { if (r.indexOf("application/x-www-form-urlencoded") > -1) return function (e, t) { return z(e, new Y.classes.URLSearchParams, Object.assign({ visitor: function (e, t, n, r) { return Y.isNode && P.isBuffer(e) ? (this.append(t, e.toString("base64")), !1) : r.defaultVisitor.apply(this, arguments) } }, t)) }(e, this.formSerializer).toString(); if ((n = P.isFileList(e)) || r.indexOf("multipart/form-data") > -1) { var s = this.env && this.env.FormData; return z(n ? { "files[]": e } : e, s && new s, this.formSerializer) } } return i || o ? (t.setContentType("application/json", !1), function (e, t, n) { if (P.isString(e)) try { return (t || JSON.parse)(e), P.trim(e) } catch (e) { if ("SyntaxError" !== e.name) throw e } return (n || JSON.stringify)(e) }(e)) : e }], transformResponse: [function (e) { var t = this.transitional || be.transitional, n = t && t.forcedJSONParsing, r = "json" === this.responseType; if (e && P.isString(e) && (n && !this.responseType || r)) { var o = !(t && t.silentJSONParsing) && r; try { return JSON.parse(e) } catch (e) { if (o) { if ("SyntaxError" === e.name) throw _.from(e, _.ERR_BAD_RESPONSE, this, null, this.response); throw e } } } return e }], timeout: 0, xsrfCookieName: "XSRF-TOKEN", xsrfHeaderName: "X-XSRF-TOKEN", maxContentLength: -1, maxBodyLength: -1, env: { FormData: Y.classes.FormData, Blob: Y.classes.Blob }, validateStatus: function (e) { return e >= 200 && e < 300 }, headers: { common: { Accept: "application/json, text/plain, */*" } } }; function ge(e, t) { var n = this || be, r = t || n, o = le.from(r.headers), i = r.data; return P.forEach(e, (function (e) { i = e.call(n, i, o.normalize(), t ? t.status : void 0) })), o.normalize(), i } function Ee(e) { return !(!e || !e.__CANCEL__) } function we(e) { if (e.cancelToken && e.cancelToken.throwIfRequested(), e.signal && e.signal.aborted) throw new re } function Oe(e) { return we(e), e.headers = le.from(e.headers), e.data = ge.call(e, e.transformRequest), (e.adapter || be.adapter)(e).then((function (t) { return we(e), t.data = ge.call(e, e.transformResponse, t), t.headers = le.from(t.headers), t }), (function (t) { return Ee(t) || (we(e), t && t.response && (t.response.data = ge.call(e, e.transformResponse, t.response), t.response.headers = le.from(t.response.headers))), Promise.reject(t) })) } function Re(e, t) { t = t || {}; var n = {}; function r(e, t) { return P.isPlainObject(e) && P.isPlainObject(t) ? P.merge(e, t) : P.isPlainObject(t) ? P.merge({}, t) : P.isArray(t) ? t.slice() : t } function o(n) { return P.isUndefined(t[n]) ? P.isUndefined(e[n]) ? void 0 : r(void 0, e[n]) : r(e[n], t[n]) } function i(e) { if (!P.isUndefined(t[e])) return r(void 0, t[e]) } function s(n) { return P.isUndefined(t[n]) ? P.isUndefined(e[n]) ? void 0 : r(void 0, e[n]) : r(void 0, t[n]) } function a(n) { return n in t ? r(e[n], t[n]) : n in e ? r(void 0, e[n]) : void 0 } var u = { url: i, method: i, data: i, baseURL: s, transformRequest: s, transformResponse: s, paramsSerializer: s, timeout: s, timeoutMessage: s, withCredentials: s, adapter: s, responseType: s, xsrfCookieName: s, xsrfHeaderName: s, onUploadProgress: s, onDownloadProgress: s, decompress: s, maxContentLength: s, maxBodyLength: s, beforeRedirect: s, transport: s, httpAgent: s, httpsAgent: s, cancelToken: s, socketPath: s, responseEncoding: s, validateStatus: a }; return P.forEach(Object.keys(e).concat(Object.keys(t)), (function (e) { var t = u[e] || o, r = t(e); P.isUndefined(r) && t !== a || (n[e] = r) })), n } P.forEach(["delete", "get", "head"], (function (e) { be.headers[e] = {} })), P.forEach(["post", "put", "patch"], (function (e) { be.headers[e] = P.merge(ve) })); var Se = "1.1.2", Ae = {};["object", "boolean", "number", "function", "string", "symbol"].forEach((function (t, n) { Ae[t] = function (r) { return e(r) === t || "a" + (n < 1 ? "n " : " ") + t } })); var je = {}; Ae.transitional = function (e, t, n) { function r(e, t) { return "[Axios v1.1.2] Transitional option '" + e + "'" + t + (n ? ". " + n : "") } return function (n, o, i) { if (!1 === e) throw new _(r(o, " has been removed" + (t ? " in " + t : "")), _.ERR_DEPRECATED); return t && !je[o] && (je[o] = !0, console.warn(r(o, " has been deprecated since v" + t + " and will be removed in the near future"))), !e || e(n, o, i) } }; var Te = { assertOptions: function (t, n, r) { if ("object" !== e(t)) throw new _("options must be an object", _.ERR_BAD_OPTION_VALUE); for (var o = Object.keys(t), i = o.length; i-- > 0;) { var s = o[i], a = n[s]; if (a) { var u = t[s], c = void 0 === u || a(u, s, t); if (!0 !== c) throw new _("option " + s + " must be " + c, _.ERR_BAD_OPTION_VALUE) } else if (!0 !== r) throw new _("Unknown option " + s, _.ERR_BAD_OPTION) } }, validators: Ae }, xe = Te.validators, Ce = function () { function e(n) { t(this, e), this.defaults = n, this.interceptors = { request: new K, response: new K } } return r(e, [{ key: "request", value: function (e, t) { "string" == typeof e ? (t = t || {}).url = e : t = e || {}; var n = (t = Re(this.defaults, t)).transitional; void 0 !== n && Te.assertOptions(n, { silentJSONParsing: xe.transitional(xe.boolean), forcedJSONParsing: xe.transitional(xe.boolean), clarifyTimeoutError: xe.transitional(xe.boolean) }, !1), t.method = (t.method || this.defaults.method || "get").toLowerCase(); var r = t.headers && P.merge(t.headers.common, t.headers[t.method]); r && P.forEach(["delete", "get", "head", "post", "put", "patch", "common"], (function (e) { delete t.headers[e] })), t.headers = new le(t.headers, r); var o = [], i = !0; this.interceptors.request.forEach((function (e) { "function" == typeof e.runWhen && !1 === e.runWhen(t) || (i = i && e.synchronous, o.unshift(e.fulfilled, e.rejected)) })); var s, a = []; this.interceptors.response.forEach((function (e) { a.push(e.fulfilled, e.rejected) })); var u, c = 0; if (!i) { var f = [Oe.bind(this), void 0]; for (f.unshift.apply(f, o), f.push.apply(f, a), u = f.length, s = Promise.resolve(t); c < u;)s = s.then(f[c++], f[c++]); return s } u = o.length; var l = t; for (c = 0; c < u;) { var d = o[c++], h = o[c++]; try { l = d(l) } catch (e) { h.call(this, e); break } } try { s = Oe.call(this, l) } catch (e) { return Promise.reject(e) } for (c = 0, u = a.length; c < u;)s = s.then(a[c++], a[c++]); return s } }, { key: "getUri", value: function (e) { return V(te((e = Re(this.defaults, e)).baseURL, e.url), e.params, e.paramsSerializer) } }]), e }(); P.forEach(["delete", "get", "head", "options"], (function (e) { Ce.prototype[e] = function (t, n) { return this.request(Re(n || {}, { method: e, url: t, data: (n || {}).data })) } })), P.forEach(["post", "put", "patch"], (function (e) { function t(t) { return function (n, r, o) { return this.request(Re(o || {}, { method: e, headers: t ? { "Content-Type": "multipart/form-data" } : {}, url: n, data: r })) } } Ce.prototype[e] = t(), Ce.prototype[e + "Form"] = t(!0) })); var Ne = function () { function e(n) { if (t(this, e), "function" != typeof n) throw new TypeError("executor must be a function."); var r; this.promise = new Promise((function (e) { r = e })); var o = this; this.promise.then((function (e) { if (o._listeners) { for (var t = o._listeners.length; t-- > 0;)o._listeners[t](e); o._listeners = null } })), this.promise.then = function (e) { var t, n = new Promise((function (e) { o.subscribe(e), t = e })).then(e); return n.cancel = function () { o.unsubscribe(t) }, n }, n((function (e, t, n) { o.reason || (o.reason = new re(e, t, n), r(o.reason)) })) } return r(e, [{ key: "throwIfRequested", value: function () { if (this.reason) throw this.reason } }, { key: "subscribe", value: function (e) { this.reason ? e(this.reason) : this._listeners ? this._listeners.push(e) : this._listeners = [e] } }, { key: "unsubscribe", value: function (e) { if (this._listeners) { var t = this._listeners.indexOf(e); -1 !== t && this._listeners.splice(t, 1) } } }], [{ key: "source", value: function () { var t; return { token: new e((function (e) { t = e })), cancel: t } } }]), e }(); var Pe = function e(t) { var n = new Ce(t), r = o(Ce.prototype.request, n); return P.extend(r, Ce.prototype, n, { allOwnKeys: !0 }), P.extend(r, n, null, { allOwnKeys: !0 }), r.create = function (n) { return e(Re(t, n)) }, r }(be); return Pe.Axios = Ce, Pe.CanceledError = re, Pe.CancelToken = Ne, Pe.isCancel = Ee, Pe.VERSION = Se, Pe.toFormData = z, Pe.AxiosError = _, Pe.Cancel = Pe.CanceledError, Pe.all = function (e) { return Promise.all(e) }, Pe.spread = function (e) { return function (t) { return e.apply(null, t) } }, Pe.isAxiosError = function (e) { return P.isObject(e) && !0 === e.isAxiosError }, Pe.formToJSON = function (e) { return Z(P.isHTMLForm(e) ? new FormData(e) : e) }, Pe }));

// // 取得 loading 元素
// function showLoading() {
//     document.querySelectorAll('.vl-full-page').forEach(function (el) {
//         el.classList.remove('d-none'); // 顯示
//     });
// }

// function hideLoading() {
//     document.querySelectorAll('.vl-full-page').forEach(function (el) {
//         el.classList.add('d-none'); // 隱藏
//     });
// }

// // 請求攔截器：發送前顯示 loading
// axios.interceptors.request.use(config => {
//     showLoading();
//     return config;
// }, error => {
//     hideLoading();
//     return Promise.reject(error);
// });

// // 回應攔截器：結束後隱藏 loading
// axios.interceptors.response.use(response => {
//     hideLoading();
//     return response;
// }, error => {
//     hideLoading();
//     return Promise.reject(error);
// });

var APIS = {

    POST: {
        async checkCreditOnly(payload) {
            try {
                const checkCreditOnly = await axios.post(`/api/credit_card/check_credit_only`, payload);
                return checkCreditOnly;
            } catch (error) {
                throw error;
            }
        },
        async salesmanCommissionUpdateStatus(payload) {
            try {
                const salesmanCommissionUpdateStatus = await axios.post(`/admin/imanage/salesman/commission/updateStatus`, payload);
                return salesmanCommissionUpdateStatus;
            } catch (error) {
                throw error;
            }
        },
        async commissionSetting(payload) {
            try {
                const commissionSetting = await axios.post(`/admin/imanage/salesman/commission-setting`, payload);
                return commissionSetting;
            } catch (error) {
                throw error;
            }
        },
        async islockByOrderIds(payload) {
            try {
                const islockByOrderIds = await axios.post(`/admin/imanage/cooperation/islockByOrderIds`, payload);
                return islockByOrderIds;
            } catch (error) {
                throw error;
            }
        },
        async exportAllianceCarAmountMileagePointCSV(payload) {
            try {
                const exportAllianceCarAmountMileagePointCSV = await axios.post(`/admin/imanage/cooperation/exportAllianceCarAmountMileagePointCSV`, payload);
                return exportAllianceCarAmountMileagePointCSV;
            } catch (error) {
                throw error;
            }
        },
        async getDataByBatchNoAndAllianceId(payload) {
            try {
                const getDataByBatchNoAndAllianceId = await axios.post(`/admin/imanage/cooperation/getDataByBatchNoAndAllianceId`, payload);
                return getDataByBatchNoAndAllianceId;
            } catch (error) {
                throw error;
            }
        },
        async getBatchNoByAllianceId(payload) {
            try {
                const getBatchNoByAllianceId = await axios.post(`/admin/imanage/cooperation/getBatchNoByAllianceId`, payload);
                return getBatchNoByAllianceId;
            } catch (error) {
                throw error;
            }
        },
        async getUnlockedLogByAllianceId(payload) {
            try {
                const getUnlockedLogByAllianceId = await axios.post(`/admin/imanage/cooperation/getUnlockedLogByAllianceId`, payload);
                return getUnlockedLogByAllianceId;
            } catch (error) {
                throw error;
            }
        },
        async allianceFeaturesUpdateOrCreateToggle(payload) {
            try {
                const allianceFeaturesUpdateOrCreateToggle = await axios.post(`/admin/imanage/cooperation/allianceFeatures/updateOrCreateToggle`, payload);
                return allianceFeaturesUpdateOrCreateToggle;
            } catch (error) {
                throw error;
            }
        },

        async createAllianceMileagePointRate(payload) {
            try {
                const createAllianceMileagePointRate = await axios.post(`/admin/imanage/cooperation/createAllianceMileagePointRate`, payload);
                return createAllianceMileagePointRate;

            } catch (error) {
                throw error;
            }
        },
        async allianceFeaturesUpdateOrCreate(payload) {
            try {
                const allianceFeaturesUpdateOrCreate = await axios.post(`/admin/imanage/cooperation/allianceFeatures/updateOrCreate`, payload);
                return allianceFeaturesUpdateOrCreate;
            } catch (error) {
                throw error;
            }
        },
        async allianceFeaturesList(page, pag = 10,) {
            try {
                const allianceFeaturesList = await axios.post(`/admin/imanage/cooperation/allianceFeatures/list?page=${page}&perPage=${pag}`);
                return allianceFeaturesList;
            } catch (error) {
                throw error;
            }
        },
        async adminCreateTicketExcel(payload) {
            try {
                const adminCreateTicketExcel = await axios.post(`/admin/imanage/FlexibleRental/adminCreateTicketExcel`, payload,
                {
                    responseType: "arraybuffer"
                });
                return adminCreateTicketExcel;
            } catch (error) {
                throw error;
            }
        },
        async insuranceCompanyDelete(payload) {
            try {
                const insuranceCompanyDelete = await axios.post(`/admin/imanage/car/insurance-company/delete`, payload);
                return insuranceCompanyDelete;
            } catch (error) {
                throw error;
            }
        },
        async insuranceCompanyCreate(payload) {
            try {
                const insuranceCompanyCreate = await axios.post(`/admin/imanage/car/insurance-company/updateOrCreate`, payload);
                return insuranceCompanyCreate;
            } catch (error) {
                throw error;
            }
        },
        async reverifyRecaptchaV2(payload) {
            try {
                const reverifyRecaptchaV2 = await axios.post(`/reverifyRecaptchaV2`, payload);
                return reverifyRecaptchaV2;
            } catch (error) {
                throw error;
            }
        },
        async reverifyRecaptchaV3(payload) {
            try {
                const reverifyRecaptchaV3 = await axios.post(`/reverifyRecaptchaV3`, payload);
                return reverifyRecaptchaV3;
            } catch (error) {
                throw error;
            }
        },
        async verifyCaptcha(payload) {
            try {
                const verifyCaptcha = await axios.post(`/verifyCaptcha`, payload);
                return verifyCaptcha;
            } catch (error) {
                throw error;
            }
        },
        async allianceBannerList(payload) {
            try {
                const bannerList = await axios.post(`/alliance/bannerList`, payload);
                return bannerList;
            } catch (error) {
                throw error;
            }
        },
        async bannerUpdate(payload ) {
            try {
                const bannerUpdate = await axios.post(`/admin/imanage/cooperation/alliance/bannerUpdate`, payload);
                return bannerUpdate;
            } catch (error) {
                throw error;
            }
        },
        async bannerDelete(payload ) {
            try {
                const bannerDelete = await axios.post(`/admin/imanage/cooperation/alliance/bannerDelete`, payload);
                return bannerDelete;
            } catch (error) {
                throw error;
            }
        },
        async bannerCreate(payload ) {
            try {
                const bannerCreate = await axios.post(`/admin/imanage/cooperation/alliance/bannerCreate`, payload);
                return bannerCreate;
            } catch (error) {
                throw error;
            }
        },
        async bannerList(payload ) {
            try {
                const bannerList = await axios.post(`/admin/imanage/cooperation/alliance/bannerList`, payload);
                return bannerList;
            } catch (error) {
                throw error;
            }
        },
        async getAlliancesMaxDeductionPoints(payload) {
            try {
                const getAlliancesMaxDeductionPoints = await axios.post(`/member/getAlliancesMaxDeductionPoints`, payload);
                return getAlliancesMaxDeductionPoints;
            } catch (error) {
                throw error;
            }
        },
        async getMemberPointsByAllianceName(payload) {
            try {
                const getMemberPointsByAllianceName = await axios.post(`/member/getMemberPointsByAllianceName`, payload);
                return getMemberPointsByAllianceName;
            } catch (error) {
                throw error;
            }
        },
        async dccInquiry(payload) {
            try {
                const dccInquiry = await axios.post(`/dccInquiry`, payload);
                return dccInquiry;
            } catch (error) {
                throw error;
            }
        },
        async createAlliancePoint(_token, payload ) {
            try {
                const createAlliancePoint = await axios.post(`/admin/imanage/cooperation/createAlliancePoint`, payload, {
                    headers: {
                        'X-CSRF-TOKEN': _token
                    }
                });
                return createAlliancePoint;
            } catch (error) {
                throw error;
            }
        },
        async exportAllianceConditionUserPointCSV(_token, payload ) {
            try {
                const exportAllianceConditionUserPointCSV = await axios.post(`/admin/imanage/cooperation/exportAllianceConditionUserPointCSV`, payload, {
                    headers: {
                        'X-CSRF-TOKEN': _token
                    }
                });
                return exportAllianceConditionUserPointCSV;
            } catch (error) {
                return error;
            }
        },
        async createAllianceConditionUserPoint(_token, payload ) {
            try {
                const createAllianceConditionUserPoint = await axios.post(`/admin/imanage/cooperation/createAllianceConditionUserPoint`, payload, {
                    headers: {
                        'X-CSRF-TOKEN': _token
                    }
                });
                return createAllianceConditionUserPoint;
            } catch (error) {
                return error;
            }
        },
        async createflexibleRentalYicketOrder(payload) {
            try {
                const createflexibleRentalYicketOrder = await axios.post(`/FlexibleRental/createflexibleRentalYicketOrder`, payload);
                return createflexibleRentalYicketOrder;
            } catch (error) {
                return error;
            }
        },
        async calculateflexibleRentalYicket(payload) {
            try {
                const calculateflexibleRentalYicket = await axios.post(`/FlexibleRental/calculateflexibleRentalYicket`, payload);
                return calculateflexibleRentalYicket;
            } catch (error) {
                return error;
            }
        },
        async canUseTicket(payload) {
            try {
                const canUseTicket = await axios.post(`/FlexibleRental/canUseTicket`, payload);
                return canUseTicket;
            } catch (error) {
                throw error;
            }
        },
        async createMemberFlexibleRentalTicket(payload) {
            try {
                const createMemberFlexibleRentalTicket = await axios.post(`/FlexibleRental/createMemberFlexibleRentalTicket`, payload);
                return createMemberFlexibleRentalTicket;
            } catch (error) {
                return error;
            }
        },
        async setCtbcMerchantFlexibleRental(_token, id, ctbc_merchant_id ) {
            const payload = {
                id: id,
                ctbc_merchant_id: ctbc_merchant_id,
            }

            try {
                const setCtbcMerchantFlexibleRental = await axios.post(`/admin/imanage/FlexibleRental/setCtbcMerchantFlexibleRental?`, payload, {
                    headers: {
                        'X-CSRF-TOKEN': _token
                    }
                });
                return setCtbcMerchantFlexibleRental;
            } catch (error) {
                return error;
            }
        },
        async getCommonDiscountInfoByGroupID(_token, pag, page, common_discount_class_group_id) {
            const payload = {
                pag: pag,
                ...(common_discount_class_group_id && { common_discount_class_group_id }),
            }

            try {
                const getCommonDiscountInfoByGroupID = await axios.post(`/admin/imanage/footer/getCommonDiscountInfoByGroupID?page=${page}
`, payload, {
                    headers: {
                        'X-CSRF-TOKEN': _token
                    }
                });
                return getCommonDiscountInfoByGroupID;
            } catch (error) {
                return error;
            }
        },
        async validateAllianceCondition(alliance_id, condition_key) {
            const payload = {
                alliance_id: alliance_id,
                condition_key: condition_key.slice(0, 6)
            }
            try {
                const validateAllianceCondition = await axios.post(`/allianceCondition/validateAllianceCondition`, payload);
                return validateAllianceCondition;
            } catch (error) {
                return error;
            }
        },
        async allianceConditionList(perPage, alliance_id) {
            const payload = {
                alliance_id: alliance_id,
                perPage: perPage
            }
            try {
                const allianceConditionList = await axios.post(`/allianceCondition/list?page=${perPage}`, payload);
                return allianceConditionList;
            } catch (error) {
                return error;
            }
        },
        async allianceConditionDestroy(_token, id) {
            const payload = {
                id: id
            }

            try {
                const allianceConditionDestroy = await axios.post(`/admin/imanage/cooperation/allianceCondition/destroy`, payload, {
                    headers: {
                        'X-CSRF-TOKEN': _token
                    }
                });
                return allianceConditionDestroy;
            } catch (error) {
                return error;
            }
        },
        async allianceConditionUpdateOrCreate(_token, alliance_id, condition_key) {
            const payload = {
                alliance_id: alliance_id,
                condition_key: condition_key,
            }

            try {
                const allianceConditionUpdateOrCreate = await axios.post(`/admin/imanage/cooperation/allianceCondition/updateOrCreate`, payload, {
                    headers: {
                        'X-CSRF-TOKEN': _token
                    }
                });
                return allianceConditionUpdateOrCreate;
            } catch (error) {
                return error;
            }
        },
        async validateAndCalculateAlliancePrice(token) {
            const payload = {
                token: token,
            }
            try {
                const validateAndCalculateAlliancePrice = await axios.post(`/alliance/validateAndCalculateAlliancePrice`, payload);
                return validateAndCalculateAlliancePrice;
            } catch (error) {
                return error;
            }
        },
        async allianceShow(id) {
            const payload = {
                id: id,
            }
            try {
                const allianceShow = await axios.post(`/alliance/show`, payload);
                return allianceShow;
            } catch (error) {
                return error;
            }
        },
        async sessionCreate(_token, car_model_id, stronghold_pick, service_id_pick, stronghold_return, service_id_return, pickup_date, pickup_time, return_date, return_time, skip, flight_number_pick, flight_number_return, day) {
            const payload = {
                car_model_id: car_model_id,
                service_name: stronghold_pick,
                service_id: service_id_pick,
                return_service_name: stronghold_return,
                return_service_id: service_id_return,
                'pickup-date': pickup_date,
                'pickup-time': pickup_time,
                'return-date': return_date,
                'return-time': return_time,
                ...(skip && { skip }),
                ...(flight_number_pick && { flight_number_pick }),
                ...(flight_number_return && { flight_number_return }),
                ...(day && { day }),
            }

            try {
                const sessionCreate = await axios.post(`/orderCache/create`, payload, {
                    headers: {
                        'X-CSRF-TOKEN': _token
                    }
                });
                return sessionCreate;
            } catch (error) {
                return error;
            }
        },
        async sessionUpdate(_token, token, car_model_id, stronghold_pick, service_id_pick, stronghold_return, service_id_return, pickup_date, pickup_time, return_date, return_time, payment_type, type_id, flight_number_pick, alliance_id, condition_key, car_amount) {
            const payload = {
                token: token,
                car_model_id: car_model_id,
                service_name: stronghold_pick,
                service_id: service_id_pick,
                return_service_name: stronghold_return,
                return_service_id: service_id_return,
                'pickup-date': pickup_date,
                'pickup-time': pickup_time,
                'return-date': return_date,
                'return-time': return_time,
                'payment-type': payment_type ? payment_type : '',
                ...(type_id && { type_id }),
                ...(flight_number_pick && { flight_number_pick }),
                ...(alliance_id && { alliance_id }),
                ...(condition_key && { condition_key }),
                ...(car_amount && { car_amount }),
            }


            try {
                const sessionUpdate = await axios.post(`/orderCache/update`, payload, {
                    headers: {
                        'X-CSRF-TOKEN': _token
                    }
                });
                return sessionUpdate;
            } catch (error) {
                return error;
            }
        },
        async sessionDelete(_token, token) {
            const payload = {
                token: token
            }

            try {
                const sessionUpdate = await axios.post(`/orderCache/delete`, payload, {
                    headers: {
                        'X-CSRF-TOKEN': _token
                    }
                });
                return sessionUpdate;
            } catch (error) {
                return error;
            }

        },
        async orderCacheShow(_token, token) {
            const payload = {
                token: token
            }

            try {
                const orderCacheShow = await axios.post(`/orderCache/show`, payload, {
                    headers: {
                        'X-CSRF-TOKEN': _token
                    }
                });
                return orderCacheShow;
            } catch (error) {
                return error;
            }

        },
        async bindMerchantToStronghold(_token, stronghold_id, ctbc_merchant_id) {
            const payload = {
                stronghold_id: stronghold_id,
                ctbc_merchant_id: ctbc_merchant_id
            }

            try {
                const bindMerchantToStronghold = await axios.post(`/admin/imanage/Payment/bindMerchantToStronghold`, payload, {
                    headers: {
                        'X-CSRF-TOKEN': _token
                    }
                });
                return bindMerchantToStronghold;
            } catch (error) {
                return error;
            }
        },
        async unbindMerchantFromStronghold(_token, stronghold_id) {
            const payload = {
                stronghold_id: stronghold_id
            }

            try {
                const unbindMerchantFromStronghold = await axios.post(`/admin/imanage/Payment/unbindMerchantFromStronghold`, payload, {
                    headers: {
                        'X-CSRF-TOKEN': _token
                    }
                });
                return unbindMerchantFromStronghold;
            } catch (error) {
                return error;
            }
        },
        async CtbcUpdateOrCreate(_token, id, Tax, company, merchantId, terminalId, MacKey, merId) {
            const payload = {
                ...(id && { id }),
                ...(Tax && { Tax }),
                ...(company && { company }),
                ...(merchantId && { merchantId }),
                ...(terminalId && { terminalId }),
                ...(MacKey && { MacKey }),
                ...(merId && { merId }),
            }

            try {
                const CtbcUpdateOrCreate = await axios.post(`/admin/imanage/Payment/CtbcUpdateOrCreate`, payload, {
                    headers: {
                        'X-CSRF-TOKEN': _token
                    }
                });
                return CtbcUpdateOrCreate;
            } catch (error) {
                return error;
            }
        },
        async getMerchantByStronghold(_token, stronghold_id) {
            const payload = {
                stronghold_id: stronghold_id
            }

            try {
                const getMerchantByStronghold = await axios.post(`/admin/imanage/Payment/getMerchantByStronghold`, payload, {
                    headers: {
                        'X-CSRF-TOKEN': _token
                    }
                });
                return getMerchantByStronghold;
            } catch (error) {
                return error;
            }
        },
        async CtbcMerchantlist(_token) {
            const payload = {
            }

            try {
                const CtbcMerchantlist = await axios.post(`/admin/imanage/Payment/CtbcMerchantlist`, payload, {
                    headers: {
                        'X-CSRF-TOKEN': _token
                    }
                });
                return CtbcMerchantlist;
            } catch (error) {
                return error;
            }
        },
        async CtbcDelete(_token, id) {
            const payload = {
                id: id
            }

            try {
                const CtbcDelete = await axios.post(`/admin/imanage/Payment/CtbcDelete`, payload, {
                    headers: {
                        'X-CSRF-TOKEN': _token
                    }
                });
                return CtbcDelete;
            } catch (error) {
                return error;
            }
        },

        async minHourList(_token, page, car_model_id, service_stronghold_id, type_id) {
            const payload = {
                ...(car_model_id && { car_model_id }),
                ...(service_stronghold_id && { service_stronghold_id }),
                ...(type_id && { type_id }),
                perPage: 10
            }

            try {
                const minHourList = await axios.post(`/stronghold/service/minHour/list?page=${page}`, payload, {
                    headers: {
                        'X-CSRF-TOKEN': _token
                    }
                });
                return minHourList;
            } catch (error) {
                return error;
            }
        },
        async minHourAllList(_token, page) {
            const payload = {
                perPage: 99999
            }

            try {
                const minHourAllList = await axios.post(`/stronghold/service/minHour/list?page=${page}`, payload, {
                    headers: {
                        'X-CSRF-TOKEN': _token
                    }
                });
                return minHourAllList;
            } catch (error) {
                return error;
            }
        },
        async minHourShow(_token, id) {
            const payload = {
                id: id
            }

            try {
                const minHourShow = await axios.post(`/stronghold/service/minHour/show`, payload, {
                    headers: {
                        'X-CSRF-TOKEN': _token
                    }
                });
                return minHourShow;
            } catch (error) {
                return error;
            }
        },
        async minHourUpdateOrCreate(_token, service_stronghold_id, car_model_id, minimum_rental_hours, type_id, id) {
            const payload = {
                service_stronghold_id: service_stronghold_id,
                car_model_id: car_model_id,
                minimum_rental_hours: minimum_rental_hours,
                ...(id && { id }),
                ...(type_id && { type_id }),
            }

            try {
                const minHourUpdateOrCreate = await axios.post(`/admin/imanage/stronghold/service/minHour/updateOrCreate`, payload, {
                    headers: {
                        'X-CSRF-TOKEN': _token
                    }
                });
                return minHourUpdateOrCreate;
            } catch (error) {
                return error;
            }
        },
        async orderCashRecordDetailDelete(_token, id) {
            const payload = {
                id: id,
            }

            try {
                const orderCashRecordDetailDelete = await axios.post(`/admin/imanage/order/orderCashRecordDetail/delete`, payload, {
                    headers: {
                        'X-CSRF-TOKEN': _token
                    }
                });
                return orderCashRecordDetailDelete;
            } catch (error) {
                return error;
            }
        },
        async orderCashRecordDetailList(_token, order_cash_record_id) {
            const payload = {
                order_cash_record_id: order_cash_record_id,
            }

            try {
                const orderCashRecordDetailList = await axios.post(`/admin/imanage/order/orderCashRecordDetail/list`, payload, {
                    headers: {
                        'X-CSRF-TOKEN': _token
                    }
                });
                return orderCashRecordDetailList;
            } catch (error) {
                return error;
            }
        },
        async orderCashRecordDetailUpdateOrCreate(_token, jsonData) {

            const payload = {
                ...jsonData
            };



            try {
                const orderCashRecordDetailUpdateOrCreate = await axios.post(`/admin/imanage/order/orderCashRecordDetail/updateOrCreate`, payload, {
                    headers: {
                        'X-CSRF-TOKEN': _token
                    }
                });
                return orderCashRecordDetailUpdateOrCreate;
            } catch (error) {
                return error;
            }
        },
        async mileageRecordDelete(_token, id) {
            const payload = {
                id: id,
            }

            try {
                const mileageRecordDelete = await axios.post(`/admin/imanage/order/mileageRecord/delete`, payload, {
                    headers: {
                        'X-CSRF-TOKEN': _token
                    }
                });
                return mileageRecordDelete;
            } catch (error) {
                return error;
            }
        },
        async mileageRecordUpdateOrCreate(_token, id, order_id, license_number, start_mileage, end_mileage, start_date, end_date) {
            const payload = {
                id: id,
                order_id: order_id,
                license_number: license_number,
                ...(start_mileage && { start_mileage }),
                ...(end_mileage && { end_mileage }),
                ...(start_date && { start_date }),
                ...(end_date && { end_date }),
            }

            try {
                const mileageRecordUpdateOrCreate = await axios.post(`/admin/imanage/order/mileageRecord/updateOrCreate`, payload, {
                    headers: {
                        'X-CSRF-TOKEN': _token
                    }
                });
                return mileageRecordUpdateOrCreate;
            } catch (error) {
                return error;
            }
        },
        async mileageRecordList(_token, order_id, perPage) {
            const payload = {
                order_id: order_id,
                perPage: perPage
            }

            try {
                const mileageRecordList = await axios.post(`/admin/imanage/order/mileageRecord/list?page=1`, payload, {
                    headers: {
                        'X-CSRF-TOKEN': _token
                    }
                });
                return mileageRecordList;
            } catch (error) {
                return error;
            }
        },
        async partnersGetList(_token, pag) {
            const payload = {
                pag: pag
            }

            try {
                const partnersGetList = await axios.post(`/partners/getList?page=1`, payload, {
                    headers: {
                        'X-CSRF-TOKEN': _token
                    }
                });
                return partnersGetList;
            } catch (error) {
                return error;
            }
        },
        async allianceList(_token, payload) {
            try {
                const allianceList = await axios.post(`/alliance/list`, payload, {
                    headers: {
                        'X-CSRF-TOKEN': _token
                    }
                });
                return allianceList;
            } catch (error) {
                return error;
            }
        },
        async redeemAllianceUserPoint(_token, payload) {
            try {
                const redeemAllianceUserPoint = await axios.post(`/member/redeemAllianceUserPoint`, payload, {
                    headers: {
                        'X-CSRF-TOKEN': _token
                    }
                });
                return redeemAllianceUserPoint;
            } catch (error) {
                throw error;
            }
        },
        async partnersDelete(_token, id) {
            const payload = {
                id: id
            }
            try {
                const partnersDelete = await axios.post(`/admin/imanage/partners/delete`, payload, {
                    headers: {
                        'X-CSRF-TOKEN': _token
                    }
                });
                return partnersDelete;
            } catch (error) {
                return error;
            }
        },
        async partnersSetPartner(_token, name, description, Partner, link_url, id, sort_order) {
            const formData = new FormData();

            formData.append('name', name);
            formData.append('description', description);
            formData.append('link_url', link_url);

            if (Partner) {
                formData.append('Partner', Partner);
            }

            if (id) {
                formData.append('id', id);
            }

            if (sort_order) {
                formData.append('sort_order', sort_order);
            }

            try {
                const partnersSetPartner = await axios.post(`/admin/imanage/partners/setPartner`, formData, {
                    headers: {
                        'X-CSRF-TOKEN': _token
                    }
                });
                return partnersSetPartner;
            } catch (error) {
                return error;
            }
        },
        async partnersBacklist(_token, page, pag) {
            const payload = {
                pag: pag,
            }

            try {
                const partnersBacklist = await axios.post(`/admin/imanage/partners/backlist?page=${page}`, payload, {
                    headers: {
                        'X-CSRF-TOKEN': _token
                    }
                });
                return partnersBacklist;
            } catch (error) {
                return error;
            }
        },
        async showCarCurrentStatuses(_token, page, status, perPage) {
            const payload = {
                status: status,
                perPage: perPage
            }

            try {
                const showCarCurrentStatuses = await axios.post(`/admin/imanage/car/showCarCurrentStatuses?page=${page}`, payload, {
                    headers: {
                        'X-CSRF-TOKEN': _token
                    }
                });
                return showCarCurrentStatuses;
            } catch (error) {
                return error;
            }
        },
        async checkCarDamageByOpenAI(_token, new_order_id) {
            const payload = {
                new_order_id: new_order_id,
            }

            try {
                const checkCarDamageByOpenAI = await axios.post(`/admin/imanage/order/checkCarDamageByOpenAI`, payload, {
                    headers: {
                        'X-CSRF-TOKEN': _token
                    }
                });
                return checkCarDamageByOpenAI;
            } catch (error) {
                return error;
            }
        },
        async orderUnconfirmedImageShow(_token, order_id) {
            const payload = {
                order_id: order_id,
                perPage: 99999
            }

            try {
                const orderUnconfirmedImageShow = await axios.post(`/admin/imanage/order/orderUnconfirmedImage/show`, payload, {
                    headers: {
                        'X-CSRF-TOKEN': _token
                    }
                });
                return orderUnconfirmedImageShow;
            } catch (error) {
                return error;
            }
        },
        async secondDriverShow(_token, order_id) {
            const payload = {
                order_id: order_id,
                pag: 99999
            }

            try {
                const secondDriverShow = await axios.post(`/admin/imanage/order/secondDriver/show?page=1`, payload, {
                    headers: {
                        'X-CSRF-TOKEN': _token
                    }
                });
                return secondDriverShow;
            } catch (error) {
                return error;
            }
        },
        async secondDriverUpdateOrCreate(_token, order_id, id, email, first_name, last_name, gender, country, birth_year, birth_month, birth_day, area_code, phone, id_number, address, id_forward_url, id_forward, id_forward_display, id_reverse_url, id_reverse, id_reverse_display, id_second_url, id_second, id_second_display, id_second_reverse_url, id_second_reverse, id_second_reverse_display) {
            const formData = new FormData();
            formData.append('order_id', order_id);

            if (id) {
                formData.append('id', id);
            }
            if (email) {
                formData.append('email', email);
            }
            if (first_name) {
                formData.append('first_name', first_name);
            }
            if (last_name) {
                formData.append('last_name', last_name);
            }
            if (gender) {
                formData.append('gender', gender);
            }
            if (country) {
                formData.append('country', country);
            }
            if (birth_year) {
                formData.append('birth_year', birth_year);
            }
            if (birth_month) {
                formData.append('birth_month', birth_month);
            }
            if (birth_day) {
                formData.append('birth_day', birth_day);
            }
            if (area_code) {
                formData.append('area_code', area_code);
            }
            if (phone) {
                formData.append('phone', phone);
            }
            if (id_number) {
                formData.append('id_number', id_number);
            }
            if (address) {
                formData.append('address', address);
            }
            if (id_forward_url) {
                formData.append('id_forward_url', id_forward_url);
            }
            if (id_forward) {
                formData.append('id_forward', id_forward);
            }
            if (id_forward_display) {
                formData.append('id_forward_display', id_forward_display);
            }
            if (id_reverse_url) {
                formData.append('id_reverse_url', id_reverse_url);
            }
            if (id_reverse) {
                formData.append('id_reverse', id_reverse);
            }
            if (id_reverse_display) {
                formData.append('id_reverse_display', id_reverse_display);
            }
            if (id_second_url) {
                formData.append('id_second_url', id_second_url);
            }
            if (id_second) {
                formData.append('id_second', id_second);
            }
            if (id_second_display) {
                formData.append('id_second_display', id_second_display);
            }
            if (id_second_reverse_url) {
                formData.append('id_second_reverse_url', id_second_reverse_url);
            }
            if (id_second_reverse) {
                formData.append('id_second_reverse', id_second_reverse);
            }
            if (id_second_reverse_display) {
                formData.append('id_second_reverse_display', id_second_reverse_display);
            }


            try {
                const secondDriverUpdateOrCreate = await axios.post(`/admin/imanage/order/secondDriver/updateOrCreate`, formData, {
                    headers: {
                        'X-CSRF-TOKEN': _token
                    }
                });
                return secondDriverUpdateOrCreate;
            } catch (error) {
                return error;
            }
        },
        async secondDriverUpdate(_token, page, id, phone, delivery_status, pag = 10) {
            const payload = {
                id: id,
                phone: phone,
                delivery_status: delivery_status,
                pag: pag
            }

            try {
                const secondDriverUpdate = await axios.post(`/admin/imanage/order/secondDriver/update`, payload, {
                    headers: {
                        'X-CSRF-TOKEN': _token
                    }
                });
                return secondDriverUpdate;
            } catch (error) {
                return error;
            }
        },
        async secondDriverUploadSecondDriversImage(_token, page, id, phone, delivery_status, pag = 10) {
            const payload = {
                id: id,
                phone: phone,
                delivery_status: delivery_status,
                pag: pag
            }

            try {
                const secondDriverUploadSecondDriversImage = await axios.post(`/admin/imanage/order/secondDriver/uploadSecondDriversImage`, payload, {
                    headers: {
                        'X-CSRF-TOKEN': _token
                    }
                });
                return secondDriverUploadSecondDriversImage;
            } catch (error) {
                return error;
            }
        },
        async getSmsLog(_token, page, id, phone, delivery_status, pag = 10) {
            const payload = {
                id: id,
                phone: phone,
                delivery_status: delivery_status,
                pag: pag
            }

            try {
                const getSmsLog = await axios.post(`/admin/imanage/sms/getSmsLog?page=${page}`, payload, {
                    headers: {
                        'X-CSRF-TOKEN': _token
                    }
                });
                return getSmsLog;
            } catch (error) {
                return error;
            }
        },
        async smsSend(_token, phone, id) {
            const payload = {
                phone: phone,
                id: id
            }

            try {
                const smsSend = await axios.post(`/admin/imanage/sms/send`, payload, {
                    headers: {
                        'X-CSRF-TOKEN': _token
                    }
                });
                return smsSend;
            } catch (error) {
                return error;
            }
        },
        async SetInsuranceData(_token, type, id, car_id, date, price,insurance_company_id) {

            const payload = {
                id: id,
                type: type,
                car_id: car_id,
                insurance_company_id: insurance_company_id,
            }

            switch (type) {
                case 'CarInsurance':
                    payload['start_date'] = date;
                    payload['insurance_amount'] = price;
                    break;
                case 'CarCoverageInsurance':
                    payload['coverage_time'] = date;
                    payload['insurance_amount'] = price;
                    break;
                case 'CarInspection':
                    payload['inspection_date'] = date;
                    break;
            }

            try {
                const SetInsuranceData = await axios.post(`/admin/imanage/car/SetInsuranceData`, payload, {
                    headers: {
                        'X-CSRF-TOKEN': _token
                    }
                });
                return SetInsuranceData;
            } catch (error) {
                alert("/admin/imanage/car/SetInsuranceData異常，請重新整理頁面或聯絡客服人員，謝謝您。")
                return error;
            }
        },
        async getInsuranceData(_token, id) {
            const payload = {
                id: id
            }

            try {
                const getInsuranceData = await axios.post(`/admin/imanage/car/getInsuranceData`, payload, {
                    headers: {
                        'X-CSRF-TOKEN': _token
                    }
                });
                return getInsuranceData;
            } catch (error) {
                alert("/admin/imanage/car/getInsuranceData異常，請重新整理頁面或聯絡客服人員，謝謝您。")
                return error;
            }
        },
        async smsDelete(_token, id) {
            const payload = {
                id: id
            }

            try {
                const smsDelete = await axios.post(`/admin/imanage/sms/delete`, payload, {
                    headers: {
                        'X-CSRF-TOKEN': _token
                    }
                });
                return smsDelete;
            } catch (error) {
                alert("/admin/imanage/sms/delete異常，請重新整理頁面或聯絡客服人員，謝謝您。")
                return error;
            }
        },
        async smsUpdateOrCreate(_token, id, stronghold_id, content) {
            const payload = {
                id: id,
                stronghold_id: stronghold_id,
                content: content,
            }

            try {
                const smsUpdateOrCreate = await axios.post(`/admin/imanage/sms/updateOrCreate`, payload, {
                    headers: {
                        'X-CSRF-TOKEN': _token
                    }
                });
                return smsUpdateOrCreate;
            } catch (error) {
                alert("/admin/imanage/sms/updateOrCreate異常，請重新整理頁面或聯絡客服人員，謝謝您。")
                return error;
            }

        },
        async getMoreProductByserviceId(_token, service_id) {
            const payload = {
                service_id: service_id
            }

            try {
                const getMoreProductByserviceId = await axios.post(`/admin/imanage/order/getMoreProductByservice_id`, payload, {
                    headers: {
                        'X-CSRF-TOKEN': _token
                    }
                });
                return getMoreProductByserviceId;
            } catch (error) {
                alert("/admin/imanage/order/getMoreProductByservice_id異常，請重新整理頁面或聯絡客服人員，謝謝您。")
                return error;
            }

        },
        async importCarInsurances(_token, payload) {
            try {
                const importCarInsurances = await axios.post(`/admin/imanage/car/importCarInsurances`, payload, {
                    headers: {
                        'X-CSRF-TOKEN': _token
                    }
                });
                return importCarInsurances;
            } catch (error) {
                alert("/admin/imanage/car/importCarInsurances異常，請重新整理頁面或聯絡客服人員，謝謝您。")
                return error;
            }

        },
        async getInsurancePrice(_token, real_pick_day, real_pick_time, real_return_day, real_return_time, car_model_id, type_id, pickup_date, pickup_time, return_date, return_time, pick_status, order_id, serial_number) {

            const payload = {
                car_model_id: car_model_id,
                type_id: type_id,
                pickup_date: pickup_date,
                pickup_time: pickup_time,
                return_date: return_date,
                return_time: return_time,
                pick_real: real_pick_day + ' ' + real_pick_time,
                return_real: real_return_day + ' ' + real_return_time,
                order_id: order_id,
                pick_status: pick_status,
                serial_number: serial_number,
            };

            try {
                const getInsurancePrice = await axios.post(`/admin/imanage/order/api/order/get_Insurance_price`, payload, {
                    headers: {
                        'X-CSRF-TOKEN': _token
                    }
                });

                return getInsurancePrice;
            } catch (error) {
                alert("/admin/imanage/order/api/order/get_Insurance_price異常，請重新整理頁面或聯絡客服人員，謝謝您。")
                return error;
            }

        },
        async SetInsurance(_token, pickup_date, pickup_time, return_date, return_time, product_id, order_id, payment_type, stronghold, last4_no_additional, serial_number) {

            const payload = {
                pickup_date: pickup_date,
                pickup_time: pickup_time,
                return_date: return_date,
                return_time: return_time,
                product_id: product_id,
                order_id: order_id,
                payment_type: payment_type,
                stronghold: stronghold,
                last4_no_additional: last4_no_additional,
                serial_number: serial_number,
            }

            try {
                const SetInsurance = await axios.post(`/admin/imanage/order/SetInsurance`, payload, {
                    headers: {
                        'X-CSRF-TOKEN': _token
                    }
                });
                return SetInsurance;
            } catch (error) {
                alert("/admin/imanage/order/SetInsurance異常，請重新整理頁面或聯絡客服人員，謝謝您。")
                return error;
            }

        },
        async carSell(_token, id, sold_date, scrapped_date, replacement_license_number, sold_price, invoice_number) {

            const payload = {
                id: id,
                sold_date: sold_date,
                scrapped_date: scrapped_date,
                replacement_license_number: replacement_license_number,
                sold_price: sold_price,
                invoice_number: invoice_number
            }

            try {
                const carSell = await axios.post(`/admin/imanage/car/sell`, payload, {
                    headers: {
                        'X-CSRF-TOKEN': _token
                    }
                });
                return carSell;
            } catch (error) {
                alert("/admin/imanage/car/sell異常，請重新整理頁面或聯絡客服人員，謝謝您。")
                return error;
            }

        },
        async deleteRecord(_token, id, order_id, type) {

            const payload = {
                id: id,
                order_id: order_id,
                type: type
            }

            try {
                const deleteRecord = await axios.post(`/admin/imanage/order/deleteRecord`, payload, {
                    headers: {
                        'X-CSRF-TOKEN': _token
                    }
                });
                return deleteRecord;
            } catch (error) {
                alert("/admin/imanage/order/deleteRecord異常，請重新整理頁面或聯絡客服人員，謝謝您。")
                return error;
            }

        },
        async importCarReport(_token, payload) {
            try {
                const importCarReport = await axios.post(`/admin/imanage/car/importCarReport`, payload, {
                    headers: {
                        'X-CSRF-TOKEN': _token
                    }
                });
                return importCarReport;
            } catch (error) {
                alert(error.response.data.error)
                return error;
            }

        },
        async updateOrCreateRecord(_token, order_id, type, price, payment_type, stronghold_id, last_4_no, id, remark, situation, Refund, Refunddate, created_at, tickets_number) {

            if (type == 'expense') {
                type = 'add';
                last_4_no = '0000';
            }

            const payload =
            {
                order_id: order_id,
                type: type,
                price: price,
                payment_type: payment_type,
                stronghold_id: stronghold_id,
                last_4_no: last_4_no,
                id: id,
                remark: remark,
                situation: situation,
                Refund: Refund,
                Refunddate: Refunddate,
                created_at: created_at,
                tickets_number: tickets_number
            }

            if (type == 'etc' || type == 'final' || type == 'prepayment') {
                payload['last4_no_etc'] = last_4_no;
            }

            try {
                const updateOrCreateRecord = await axios.post(`/admin/imanage/order/updateOrCreateRecord`, payload, {
                    headers: {
                        'X-CSRF-TOKEN': _token
                    }
                });
                return updateOrCreateRecord;
            } catch (error) {
                alert("/admin/imanage/order/updateOrCreateRecord異常，請重新整理頁面或聯絡客服人員，謝謝您。")
                return error;
            }

        },
        async throttleLogUpdate(_token, ip, status, id) {
            const payload =
            {
                ip: ip,
                status: status,
                id: id
            }
            try {
                const throttleLogUpdate = await axios.post(`/admin/imanage/throttle_log/update`, payload, {
                    headers: {
                        'X-CSRF-TOKEN': _token
                    }
                });
                return throttleLogUpdate;
            } catch (error) {
                alert("/admin/imanage/throttle_log/update異常，請重新整理頁面或聯絡客服人員，謝謝您。")
                return error;
            }

        },
        async throttleLogStore(_token, ip, status) {
            const payload =
            {
                ip: ip,
                status: status
            }
            try {
                const throttleLogStore = await axios.post(`/admin/imanage/throttle_log/store`, payload, {
                    headers: {
                        'X-CSRF-TOKEN': _token
                    }
                });
                return throttleLogStore;
            } catch (error) {
                alert("/admin/imanage/throttle_log/store異常，請重新整理頁面或聯絡客服人員，謝謝您。")
                return error;
            }

        },
        async throttleLogDestroy(_token, id) {
            const payload =
            {
                id: id
            }
            try {
                const throttleLogDestroy = await axios.post(`/admin/imanage/throttle_log/destroy?id=${id}`, payload, {
                    headers: {
                        'X-CSRF-TOKEN': _token
                    }
                });
                return throttleLogDestroy;
            } catch (error) {
                alert("/admin/imanage/throttle_log/destroy異常，請重新整理頁面或聯絡客服人員，謝謝您。")
                return error;
            }

        },
        async getTypeByCarModelId(_token, car_model_id, pag) {
            const payload =
            {
                car_model_id: car_model_id,
                pag: pag,
            }
            try {
                const getTypeByCarModelId = await axios.post(`/getTypeByCar_model_id`, payload, {
                    headers: {
                        'X-CSRF-TOKEN': _token
                    }
                });
                return getTypeByCarModelId;
            } catch (error) {
                alert("/getTypeByCar_model_id異常，請重新整理頁面或聯絡客服人員，謝謝您。")
                return error;
            }

        },
        async sendVerificationCode(_token, account) {
            const payload =
            {
                account: account,
            }
            try {
                const sendVerificationCode = await axios.post(`/admin/sendVerificationCode?account=${account}`, payload, {
                    headers: {
                        'X-CSRF-TOKEN': _token
                    }
                });
                return sendVerificationCode;
            } catch (error) {
                alert("/admin/sendVerificationCode異常，請重新整理頁面或聯絡客服人員，謝謝您。")
                return error;
            }

        },
        async getFuelCardExpense(_token, type_id, end_mileage, start_mileage) {
            const payload =
            {
                type_id: type_id,
                end_mileage: end_mileage,
                start_mileage: start_mileage
            }
            try {
                const getFuelCardExpense = await axios.post(`/admin/imanage/getFuelCardExpense`, payload, {
                    headers: {
                        'X-CSRF-TOKEN': _token
                    }
                });
                return getFuelCardExpense;
            } catch (error) {
                alert("/admin/imanage/getFuelCardExpense異常，請重新整理頁面或聯絡客服人員，謝謝您。")
                return error;
            }

        },
        async rate_description_update(_token, content) {
            const payload =
            {
                content: content
            }
            try {
                const rate_description_update = await axios.post(`/admin/imanage/integral/rate_description/update`, payload, {
                    headers: {
                        'X-CSRF-TOKEN': _token
                    }
                });
                return rate_description_update;
            } catch (error) {
                alert("/admin/imanage/integral/rate_description/update異常，請重新整理頁面或聯絡客服人員，謝謝您。")
                return error;
            }

        },
        async process(_token, cvv2, card_no, exp_year, exp_month, auth_amt, order_number, TOKEN, amount, details, message_type, id, stronghold, type, TrafficTicket_id, DccTokenId, DccCurrency, DccRate, DccAmt, DccFee, lidm) {

            const payload =
            {
                CVV2:cvv2,
                card_no: card_no,
                exp_year: exp_year,
                exp_month: exp_month,
                auth_amt: auth_amt,
                order_number: order_number,
                'X-CSRF-TOKEN': TOKEN,
                amount: amount,
                details: details,
                message_type: message_type,
                id: id,
                stronghold: stronghold,
                type: type,
                ...(TrafficTicket_id && { TrafficTicket_id }),
                DccTokenId: DccTokenId,
                Currency: DccCurrency,
                DccRate: DccRate,
                DccAmt: DccAmt,
                DccFee: DccFee,
                lidm: lidm,
            }

            try {

                const process = await axios.post(`/api/payment/process`, payload, {
                    headers: {
                        'X-CSRF-TOKEN': _token
                    }
                });
                return process;
            } catch (error) {
                return error;
            }
        },
        async delNonBusinessHoursCharge(_token, stronghold_id) {

            const payload =
            {
                stronghold_id: stronghold_id
            }

            try {

                const delNonBusinessHoursCharge = await axios.post(`/admin/imanage/stronghold/delNonBusinessHoursCharge`, payload, {
                    headers: {
                        'X-CSRF-TOKEN': _token
                    }
                });
                return delNonBusinessHoursCharge;
            } catch (error) {
                return error;
            }
        },
        async getNonBusinessHoursCharge(_token, page) {

            const payload =
            {
                pag: 10
            }

            try {

                const getNonBusinessHoursCharge = await axios.post(`/admin/imanage/stronghold/getNonBusinessHoursCharge?page=${page}`, payload, {
                    headers: {
                        'X-CSRF-TOKEN': _token
                    }
                });
                return getNonBusinessHoursCharge;
            } catch (error) {
                return error;
            }
        },
        async setNonBusinessHoursChaRge(_token, stronghold_id, start_time, end_time, fee, id) {
            const payload =
            {
                stronghold_id: stronghold_id,
                start_time: start_time,
                end_time: end_time,
                fee: fee,
            }

            try {

                const setNonBusinessHoursChaRge = await axios.post(`/admin/imanage/stronghold/setNonBusinessHoursCharge`, payload, {
                    headers: {
                        'X-CSRF-TOKEN': _token
                    }
                });
                return setNonBusinessHoursChaRge;
            } catch (error) {
                return error;
            }
        },
        async getCaptcha(_token) {
            const payload =
            {
                csrf: _token
            }

            try {

                const getCaptcha = await axios.post(`/getCaptcha`, payload, {
                    headers: {
                        'X-CSRF-TOKEN': _token
                    }
                });
                return getCaptcha;
            } catch (error) {
                return error;
            }
        },
        async customerFeedbackSetData(_token, id, processing_status, remark) {
            const payload =
            {
                id: id,
                processing_status: processing_status,
                remark: remark
            }

            try {

                const customerFeedbackSetData = await axios.post(`/admin/imanage/customer_feedback/setData`, payload, {
                    headers: {
                        'X-CSRF-TOKEN': _token
                    }
                });
                return customerFeedbackSetData;
            } catch (error) {
                return error;
            }
        },
        async getVendorConsultationServices(_token, page) {
            console.log(_token, page)

            const payload =
            {
                pag: 10
            }

            try {

                const setVendorConsultationServices = await axios.post(`/admin/imanage/vendor-consultations/getVendorConsultationServices?page=${page}`, payload, {
                    headers: {
                        'X-CSRF-TOKEN': _token
                    }
                });
                return setVendorConsultationServices;
            } catch (error) {
                return error;
            }
        },
        async webSetVendorConsultationServices(formData, _token) {

            // const payload = {
            //     company_name: company_name,
            //     contact_person: contact_person,
            //     contact_phone: contact_phone,
            //     email: email,
            //     ...(brand_name && { brand_name }),
            //     ...(contact_area_code && { contact_area_code }),
            //     ...(tax_id && { tax_id }),
            //     ...(company_website && { company_website }),
            //     ...(proposal_document && { proposal_document }),
            //     ...(description && { description }),
            // };

            try {

                const setVendorConsultationServices = await axios.post(`/api/vendor-consultations/setVendorConsultationServices`, formData, {
                    headers: {
                        'X-CSRF-TOKEN': _token
                    }
                });
                return setVendorConsultationServices;
            } catch (error) {
                return error;
            }
        },
        async setVendorConsultationServices(_token, id, company_name, contact_person, contact_phone, email, status, remark) {

            const payload = {
                id: id,
                company_name: company_name,
                contact_person: contact_person,
                contact_phone: contact_phone,
                email: email,
                status: status,
                remark: remark
            };

            try {

                const setVendorConsultationServices = await axios.post(`/admin/imanage/setVendorConsultationServices`, payload, {
                    headers: {
                        'X-CSRF-TOKEN': _token
                    }
                });
                return setVendorConsultationServices;
            } catch (error) {
                return error;
            }
        },
        async getAllianceList(_token, page, pag = 10) {

            const payload =
            {
                pag: pag
            }

            try {

                const allianceList = await axios.post(`/admin/imanage/cooperation/alliance/list?page=${page}`, payload, {
                    headers: {
                        'X-CSRF-TOKEN': _token
                    }
                });
                return allianceList;
            } catch (error) {
                return error;
            }
        },
        async allianceUpdateOrCreate(_token, name, logo_path, css, discount_rate, status, id, seo_keywords, seo_description, seo_str, member_alliance_logo_path) {
            const payload = new FormData();


            payload.append('name', name);
            payload.append('logo', logo_path);
            // payload.append('banner', banner_path);

            // for (let i = 0; i < banner_path.length; i++) {
            //     payload.append('banner[]', banner_path[i]);
            // }

            payload.append('css', css);
            payload.append('discount_rate', discount_rate);
            payload.append('status', status);
            payload.append('seo_keywords', seo_keywords);
            payload.append('seo_description', seo_description);
            payload.append('seo_str', seo_str);
            payload.append('member_alliance_logo', member_alliance_logo_path);


            if (id) {
                payload.append('id', id);
            }

            try {

                const allianceUpdateOrCreate = await axios.post(`/admin/imanage/cooperation/alliance/updateOrCreate`, payload, {
                    headers: {
                        'X-CSRF-TOKEN': _token
                    }
                });
                return allianceUpdateOrCreate;
            } catch (error) {
                return error;
            }
        },
        async allianceDelete(_token, id) {

            const payload =
            {
                id: id
            }

            try {

                const allianceDelete = await axios.post(`/admin/imanage/cooperation/alliance/destroy`, payload, {
                    headers: {
                        'X-CSRF-TOKEN': _token
                    }
                });
                return allianceDelete;
            } catch (error) {
                return error;
            }
        },
        async setAllianceDate(_token, id, name, logo_path, banner_path, css, discount_rate, status) {

            const payload = {
                id: id,
                name: name,
                logo_path: logo_path,
                banner_path: banner_path,
                css: css,
                discount_rate: discount_rate,
                status: status,
            };

            try {

                const setAllianceDate = await axios.post(`/admin/imanage/order/alliance/updateOrCreate`, payload, {
                    headers: {
                        'X-CSRF-TOKEN': _token
                    }
                });
                return setAllianceDate;
            } catch (error) {
                return error;
            }
        },
        async storeLongCarRentalStore(Captchastr, name, area_code, phone, email, tax_id, feedback, county_id, _token, status) {

            const payload = {
                Captchastr: Captchastr,
                name: name,
                area_code: area_code,
                phone: phone,
                email: email,
                tax_id: tax_id,
                feedback: feedback,
                county_id: county_id,
                status: status
            };

            try {

                const storeLongCarRentalStore = await axios.post(`/api/storeLongCarRental/store`, payload, {
                    headers: {
                        'X-CSRF-TOKEN': _token
                    }
                });
                return storeLongCarRentalStore;
            } catch (error) {
                return error;
            }
        },
        async getCalendar(_token, year, month) {
            const payload = {
                year: year,
                month: month
            };
            try {

                const getCalendar = await axios.post(`/calendar/getCalendar`, payload, {
                    headers: {
                        'X-CSRF-TOKEN': _token
                    }
                });
                return getCalendar;
            } catch (error) {
                return error;
            }
        },
        async updateCalendarDataById(_token, id, is_holiday, remarks) {
            const payload = {
                id: id,
                is_holiday: is_holiday,
                remarks: remarks,
            };

            try {

                const updateCalendarDataById = await axios.post(`/admin/imanage/calendar/updateCalendarDataById`, payload, {
                    headers: {
                        'X-CSRF-TOKEN': _token
                    }
                });
                return updateCalendarDataById;
            } catch (error) {
                return error;
            }
        },
        async JsonToCalendar(_token, file) {
            const formData = new FormData();
            formData.append('Calendar', file);

            try {

                const JsonToCalendar = await axios.post(`/admin/imanage/calendar/JsonToCalendar`, formData, {
                    headers: {
                        'X-CSRF-TOKEN': _token
                    }
                });
                return JsonToCalendar;
            } catch (error) {
                return error;
            }
        },
        async type_update_interval(_token, type, start, end, price_type) {
            const payload = {
                type: type,
                start: start,
                end: end,
                price_type: price_type
            };
            try {

                const type_update_interval = await axios.post(`/admin/imanage/calendar/type_update_interval`, payload, {
                    headers: {
                        'X-CSRF-TOKEN': _token
                    }
                });
                return type_update_interval;
            } catch (error) {
                return error;
            }
        },
        async setDiscountInfoClassSort(_token, payloadPara) {//change
            const payload = payloadPara;
            try {

                const setDiscountInfoClassSort = await axios.post(`/admin/imanage/footer/setDiscountInfoClassSort`, payload, {
                    headers: {
                        'X-CSRF-TOKEN': _token
                    }
                });
                return setDiscountInfoClassSort;
            } catch (error) {
                return error;
            }
        },
        async frontCommonDiscountInfo(_token, id, page) {//change
            const payload =
            {
                id: id,
                pag: 9,
            }
            try {

                const frontCommonDiscountInfo = await axios.post(`/CommonDiscountInfo/frontCommonDiscountInfo?page=${page}`, payload, {
                    headers: {
                        'X-CSRF-TOKEN': _token
                    }
                });
                return frontCommonDiscountInfo;
            } catch (error) {
                return error;
            }
        },
        async getfrontDiscountInfoClass(_token, pag, page) {//change
            const payload =
            {
                pag: pag
            }
            try {

                const getfrontDiscountInfoClass = await axios.post(`/CommonDiscountInfo/getfrontDiscountInfoClass?page=${page}`, payload, {
                    headers: {
                        'X-CSRF-TOKEN': _token
                    }
                });
                return getfrontDiscountInfoClass;
            } catch (error) {
                return error;
            }
        },
        async DiscountInfoClasstoggleVisibility(_token, id, lang) {//change
            const payload =
            {
                id: id,
                lang: lang
            }
            try {

                const DiscountInfoClasstoggleVisibility = await axios.post(`/admin/imanage/footer/DiscountInfoClasstoggleVisibility`, payload, {
                    headers: {
                        'X-CSRF-TOKEN': _token
                    }
                });
                return DiscountInfoClasstoggleVisibility;
            } catch (error) {
                return error;
            }
        },
        async CommonDiscountInfoClassUpdateOrCreate(_token, ch_name, lang, common_discount_class_group_id, id) {//change
            const payload =
            {
                ...(id && { id }),
                ch_name: ch_name,
                lang: lang,
                ...(common_discount_class_group_id && { common_discount_class_group_id }),
            }
            try {

                const CommonDiscountInfoClassUpdateOrCreate = await axios.post(`/admin/imanage/footer/CommonDiscountInfoClassUpdateOrCreate`, payload, {
                    headers: {
                        'X-CSRF-TOKEN': _token
                    }
                });
                return CommonDiscountInfoClassUpdateOrCreate;
            } catch (error) {
                return error;
            }
        },
        async getbackDiscountInfoClass(_token, pag, page, lang) {//change
            const payload =
            {
                pag: pag,
                lang: lang
            }
            try {

                const getbackDiscountInfoClass = await axios.post(`/admin/imanage/footer/getbackDiscountInfoClass?page=${page}`, payload, {
                    headers: {
                        'X-CSRF-TOKEN': _token
                    }
                });
                return getbackDiscountInfoClass;
            } catch (error) {
                return error;
            }
        },
        async backgetCommonDiscountInfo(_token, pag, page, lang, id) {//change
            const payload =
            {
                pag: pag,
                lang: lang,
                id: id
            }
            try {

                const backgetCommonDiscountInfo = await axios.post(`/admin/imanage/footer/backgetCommonDiscountInfo?page=${page}`, payload, {
                    headers: {
                        'X-CSRF-TOKEN': _token
                    }
                });
                return backgetCommonDiscountInfo;
            } catch (error) {
                return error;
            }
        },
        async Del_ContinuousHolidayPinkDay(_token, id) {
            const payload =
            {
                id: id
            }
            try {

                const Del_ContinuousHolidayPinkDay = await axios.post(`/admin/imanage/continuous-holiday-set/Del_ContinuousHolidayPinkDay`, payload, {
                    headers: {
                        'X-CSRF-TOKEN': _token
                    }
                });
                return Del_ContinuousHolidayPinkDay;
            } catch (error) {
                return error;
            }
        },
        async Del_ContinuousHolidayReturnDay(_token, id) {
            const payload =
            {
                id: id
            }
            try {

                const Del_ContinuousHolidayReturnDay = await axios.post(`/admin/imanage/continuous-holiday-set/Del_ContinuousHolidayReturnDay`, payload, {
                    headers: {
                        'X-CSRF-TOKEN': _token
                    }
                });
                return Del_ContinuousHolidayReturnDay;
            } catch (error) {
                return error;
            }
        },
        async typeImgSort(_token, id, sort) {
            const payload =
            {
                id: id,
                sort: sort
            }
            try {

                const typeImgSort = await axios.post(`/admin/imanage/car-model/type_ImgSort`, payload, {
                    headers: {
                        'X-CSRF-TOKEN': _token
                    }
                });
                return typeImgSort;
            } catch (error) {
                return error;
            }
        },
        async frontCommonQuestion(_token, id, pag, page) {
            const payload =
            {
                id: id,
                pag: pag,
            }
            try {

                const frontCommonQuestion = await axios.post(`/CommonQuestion/frontCommonQuestion?page=${page}`, payload, {
                    headers: {
                        'X-CSRF-TOKEN': _token
                    }
                });
                return frontCommonQuestion;
            } catch (error) {
                return error;
            }
        },
        async getfrontQuestionClass(_token, pag, page) {
            const payload =
            {
                pag: pag,
            }
            try {

                const getfrontQuestionClass = await axios.post(`/CommonQuestion/getfrontQuestionClass?page=${page}`, payload, {
                    headers: {
                        'X-CSRF-TOKEN': _token
                    }
                });
                return getfrontQuestionClass;
            } catch (error) {
                return error;
            }
        },
        async backgetCommonQuestion(_token, id) {
            const payload =
            {
                id: id,
            }
            try {

                const backgetCommonQuestion = await axios.post(`/admin/imanage/footer/backgetCommonQuestion`, payload, {
                    headers: {
                        'X-CSRF-TOKEN': _token
                    }
                });
                return backgetCommonQuestion;
            } catch (error) {
                return error;
            }
        },
        async QuestionClasstoggleVisibility(_token, id) {
            const payload =
            {
                id: id,
            }
            try {

                const QuestionClasstoggleVisibility = await axios.post(`/admin/imanage/footer/QuestionClasstoggleVisibility`, payload, {
                    headers: {
                        'X-CSRF-TOKEN': _token
                    }
                });
                return QuestionClasstoggleVisibility;
            } catch (error) {
                return error;
            }
        },
        async CommonQuestionClassUpdateOrCreate(_token, ch_name, id, lang) {
            const payload =
            {
                ...(id && { id }),
                ch_name: ch_name,
                lang: lang
            }
            try {

                const CommonQuestionClassUpdateOrCreate = await axios.post(`/admin/imanage/footer/CommonQuestionClassUpdateOrCreate`, payload, {
                    headers: {
                        'X-CSRF-TOKEN': _token
                    }
                });
                return CommonQuestionClassUpdateOrCreate;
            } catch (error) {
                return error;
            }
        },
        async getbackQuestionClass(_token, pag, page, lang) {
            const payload =
            {
                pag: pag,
                lang: lang
            }
            try {

                const getbackQuestionClass = await axios.post(`/admin/imanage/footer/getbackQuestionClass?page=${page}`, payload, {
                    headers: {
                        'X-CSRF-TOKEN': _token
                    }
                });
                return getbackQuestionClass;
            } catch (error) {
                return error;
            }
        },
        async repair(_token, id, repair) {
            const payload =
            {
                id: id,
                repair: repair
            }
            try {

                const repair = await axios.post(`/admin/imanage/car/repair`, payload, {
                    headers: {
                        'X-CSRF-TOKEN': _token
                    }
                });
                return repair;
            } catch (error) {
                return error;
            }
        },
        async getDelDriverServiceFee(_token, pag, page) {
            const payload =
            {
                pag: pag,
            }
            try {

                const getDelDriverServiceFee = await axios.post(`/admin/imanage/designated-driving/getDelDriverServiceFee?page=${page}`, payload, {
                    headers: {
                        'X-CSRF-TOKEN': _token
                    }
                });
                return getDelDriverServiceFee;
            } catch (error) {
                return error;
            }
        },
        async DelDriverServiceFee(_token, id) {
            const payload =
            {
                id: id,
            }
            try {

                const DelDriverServiceFee = await axios.post(`/admin/imanage/designated-driving/DelDriverServiceFee`, payload, {
                    headers: {
                        'X-CSRF-TOKEN': _token
                    }
                });
                return DelDriverServiceFee;
            } catch (error) {
                return error;
            }
        },
        async setDriverServiceFee(_token, start_date, end_date, fee_percentage, id) {
            const payload =
            {
                ...(id && { id }),
                start_date: start_date,
                end_date: end_date,
                fee_percentage: fee_percentage
            }
            try {

                const setDriverServiceFee = await axios.post(`/admin/imanage/designated-driving/setDriverServiceFee`, payload, {
                    headers: {
                        'X-CSRF-TOKEN': _token
                    }
                });
                return setDriverServiceFee;
            } catch (error) {
                return error;
            }
        },
        async setLineMessengerToken(_token, id) {
            try {
                const payload =
                {
                    id: id
                }
                const setLineMessengerToken = await axios.post(`/admin/imanage/stronghold/setLineMessengerToken`, payload, {
                    headers: {
                        'X-CSRF-TOKEN': _token
                    }
                });
                return setLineMessengerToken;
            } catch (error) {
                return error;
            }
        },
        async orderByInvoice(_token, orderby = 'asc', pag, page, invoice) {
            // orderby	string
            // asc/desc
            try {
                const payload =
                {
                    orderby: orderby,
                    pag: pag,
                    ...(invoice && { invoice }),
                }

                const orderByInvoice = await axios.post(`/admin/imanage/order/orderByInvoice?page=${page}`, payload, {
                    headers: {
                        'X-CSRF-TOKEN': _token
                    }
                });
                return orderByInvoice;
            } catch (error) {
                return error;
            }
        },
        async getDriverRentalWeb(_token) {
            try {

                const getDriverRentalWeb = await axios.post(`/getDriverRental`, {
                    headers: {
                        'X-CSRF-TOKEN': _token
                    }
                });
                return getDriverRentalWeb;
            } catch (error) {
                return error;
            }
        },
        async getDriverRental(_token) {
            try {

                const getDriverRental = await axios.post(`/admin/imanage/designated-driving/getDriverRental`, {
                    headers: {
                        'X-CSRF-TOKEN': _token
                    }
                });
                return getDriverRental;
            } catch (error) {
                return error;
            }
        },
        async setDriverRental(_token, hour, price, id) {
            try {
                const payload =
                {
                    hour: hour,
                    price: price,
                    id: id
                }

                const setDriverRental = await axios.post(`/admin/imanage/designated-driving/setDriverRental`, payload, {
                    headers: {
                        'X-CSRF-TOKEN': _token
                    }
                });
                return setDriverRental;
            } catch (error) {
                return error;
            }
        },
        async setOrganization(_token, id, name) {
            try {
                const payload =
                {
                    name: name,
                    ...(id && { id }),
                }

                const setOrganization = await axios.post(`/admin/imanage/designated-driving/setOrganization`, payload, {
                    headers: {
                        'X-CSRF-TOKEN': _token
                    }
                });
                return setOrganization;
            } catch (error) {
                return error;
            }
        },
        async setAddress(_token, organization_id, address, id, name) {
            try {
                const payload =
                {
                    organization_id: organization_id,
                    address: address,
                    name: name,
                    ...(id && { id }),
                }

                const setAddress = await axios.post(`/admin/imanage/designated-driving/setAddress`, payload, {
                    headers: {
                        'X-CSRF-TOKEN': _token
                    }
                });
                return setAddress;
            } catch (error) {
                return error;
            }
        },
        async getOrganizationlist(_token, page) {
            try {
                const payload =
                {
                    pag: 100000
                }

                const getOrganizationlist = await axios.post(`/driver/getOrganizationlist?page=${page}`, payload, {
                    headers: {
                        'X-CSRF-TOKEN': _token
                    }
                });
                return getOrganizationlist;
            } catch (error) {
                return error;
            }
        },
        async updateFareManagement(_token, car_model_id, Insurance, type_id, pickup_date, return_date, coTenant) {
            try {
                const payload =
                {
                    car_model_id: car_model_id,
                    Insurance: Insurance,
                    type_id: type_id,
                    pickup_date: pickup_date,
                    return_date: return_date,
                }

                const coTenantFees = await axios.post(`/admin/imanage/designated-driving/api/updateFareManagement`, payload, {
                    headers: {
                        'X-CSRF-TOKEN': _token
                    }
                });
                return coTenantFees;
            } catch (error) {
                return error;
            }
        },
        async coTenantFees(_token, car_model_id, Insurance, type_id, pickup_date, return_date, coTenant,  serial_number=null) {
            try {
                const payload =
                {
                    car_model_id: car_model_id,
                    Insurance: Insurance,
                    type_id: type_id,
                    pickup_date: pickup_date,
                    return_date: return_date,
                    serial_number:serial_number,
                }

                const coTenantFees = await axios.post(`/coTenantFees`, payload, {
                    headers: {
                        'X-CSRF-TOKEN': _token
                    }
                });
                return coTenantFees;
            } catch (error) {
                return error;
            }
        },
        async calculateAreaFee(_token, adders) {
            try {
                const payload =
                {
                    adders: adders,
                }

                const calculateAreaFee = await axios.post(`/driver/calculateAreaFee`, payload, {
                    headers: {
                        'X-CSRF-TOKEN': _token
                    }
                });
                return calculateAreaFee;
            } catch (error) {
                return error;
            }
        },
        async DelArea(_token, id) {
            try {
                const payload =
                {
                    id: id,
                }

                const DelArea = await axios.post(`/admin/imanage/designated-driving/DelArea`, payload, {
                    headers: {
                        'X-CSRF-TOKEN': _token
                    }
                });
                return DelArea;
            } catch (error) {
                return error;
            }
        },
        async updateOrCreateArea(_token, id, county_id, extra_fee, name) {
            try {
                const payload =
                {
                    id: id,
                    county_id: county_id,
                    extra_fee: extra_fee,
                    name: name
                }

                const updateOrCreateArea = await axios.post(`/admin/imanage/designated-driving/updateOrCreateArea`, payload, {
                    headers: {
                        'X-CSRF-TOKEN': _token
                    }
                });
                return updateOrCreateArea;
            } catch (error) {
                return error;
            }
        },
        async getArea(_token, county_id, page) {
            try {
                const payload =
                {
                    pag: 10,
                    county_id: county_id,
                }

                const getArea = await axios.post(`/getArea?page=${page}`, payload, {
                    headers: {
                        'X-CSRF-TOKEN': _token
                    }
                });
                return getArea;
            } catch (error) {
                return error;
            }
        },
        async toggleSubscriptionGroupVehicleDeleteRestore(_token, car_id) {
            // 創建 FormData 物件
            //             car_id（必填）
            // rental_period_id（必填）
            // rentalService_id（選填）
            // let _token = await APIS.GET.getCSRFTokenApi();
            try {
                const payload =
                {
                    id: car_id
                }

                const toggleSubscriptionGroupVehicleDeleteRestore = await axios.post(`/admin/imanage/CarSubscription/toggleSubscriptionGroupVehicleDeleteRestore`, payload, {
                    headers: {
                        'X-CSRF-TOKEN': _token
                    }
                });
                return toggleSubscriptionGroupVehicleDeleteRestore;
            } catch (error) {
                return error;
            }
        },
        async addSubscriptionOrderCashRecord(_token, dataObj) {
            // 創建 FormData 物件
            //             car_id（必填）
            // rental_period_id（必填）
            // rentalService_id（選填）
            // let _token = await APIS.GET.getCSRFTokenApi();
            try {
                const payload =
                {
                    ...dataObj
                }

                const addSubscriptionOrderCashRecord = await axios.post(`/admin/imanage/order/addSubscriptionOrderCashRecord`, payload, {
                    headers: {
                        'X-CSRF-TOKEN': _token
                    }
                });
                return addSubscriptionOrderCashRecord;
            } catch (error) {
                return error;
            }
        },
        async GetCarStrongholdId(_token, id) {
            // 創建 FormData 物件
            //             car_id（必填）
            // rental_period_id（必填）
            // rentalService_id（選填）
            // let _token = await APIS.GET.getCSRFTokenApi();
            try {
                const payload =
                    { id: id };

                const GetCarStrongholdId = await axios.post(`/stronghold/GetCarStronghold_id`, payload, {
                    headers: {
                        'X-CSRF-TOKEN': _token
                    }
                });
                return GetCarStrongholdId;
            } catch (error) {
                return error;
            }
        },
        async getCarPeriodAndService(_token, license_number) {
            // 創建 FormData 物件
            //             car_id（必填）
            // rental_period_id（必填）
            // rentalService_id（選填）
            // let _token = await APIS.GET.getCSRFTokenApi();
            try {
                const payload =
                    { license_number: license_number };

                const getCarPeriodAndService = await axios.post(`/admin/imanage/CarSubscription/getCarPeriodAndService`, payload, {
                    headers: {
                        'X-CSRF-TOKEN': _token
                    }
                });
                return getCarPeriodAndService;
            } catch (error) {
                return error;
            }
        },
        async UpdateSubscriptionCarOrder(_token, form) {
            // 不知用途
            //             "cash_amount"
            // "overtime_amount"
            // "last4_no_additional"
            // "mileage"
            // driver_license_authority_number
            // 創建 FormData 物件
            //             car_id（必填）
            // rental_period_id（必填）
            // rentalService_id（選填）
            // let _token = await APIS.GET.getCSRFTokenApi();
            try {
                const payload = form;

                const UpdateSubscriptionCarOrder = await axios.post(`/admin/imanage/CarSubscription/UpdateSubscriptionCarOrder`, payload, {
                    headers: {
                        'X-CSRF-TOKEN': _token
                    }
                });
                return UpdateSubscriptionCarOrder;
            } catch (error) {
                return error;
            }
        },
        ///getOrderDetails
        async getOrderDetails(_token, id) {
            //             car_id（必填）
            // rental_period_id（必填）
            // rentalService_id（選填）
            // let _token = await APIS.GET.getCSRFTokenApi();
            try {
                const payload = {
                    csrf_token: _token,
                    id: id,
                };

                const getOrderDetails = await axios.post(`/admin/imanage/order/getOrderDetails`, payload, {
                    headers: {
                        'X-CSRF-TOKEN': _token
                    }
                });
                return getOrderDetails;
            } catch (error) {
                return error;
            }
        },
        async getSubscriptionOrder(_token, { type, create_date, close_date, pickup_date, return_date, stronghold, order_status, pay_status, name, phone, id_number, order_number, contract_number, invoice, promo_code }, page) {

            // "type": "to_be_contacted",
            // "create_date": "2024-10-24",
            // "close_date": "2024-10-24",
            // "pickup_date": "2024-10-24",
            // "return_date": "2024-10-24",
            // "stronghold": 0,
            // "order_status": "string",
            // "pay_status": "string",
            // "name": "string",
            // "phone": "string",
            // "id_number": "string",
            // "order_number": "string",
            // "contract_number": "string",
            // "invoice": "string",
            // "promo_code": "string"

            // let _token = await APIS.GET.getCSRFTokenApi();
            try {
                const payload = {
                    csrf_token: _token,
                    pag: 10,
                    ...(type && { type }),
                    ...(create_date && { create_date }),
                    ...(close_date && { close_date }),
                    ...(pickup_date && { pickup_date }),
                    ...(return_date && { return_date }),
                    ...(stronghold && { stronghold }),
                    ...(order_status && { order_status }),
                    ...(pay_status && { pay_status }),
                    ...(name && { name }),
                    ...(phone && { phone }),
                    ...(id_number && { id_number }),
                    ...(order_number && { order_number }),
                    ...(contract_number && { contract_number }),
                    ...(invoice && { invoice }),
                    ...(promo_code && { promo_code }),
                };

                const getSubscriptionOrder = await axios.post(`/admin/imanage/CarSubscription/getorder?page=${page}`, payload, {
                    headers: {
                        'X-CSRF-TOKEN': _token
                    }
                });
                return getSubscriptionOrder;
            } catch (error) {
                return error;
            }
        },
        async createSubscriptionCarOrder(_token, car_id, stronghold_id, rental_period_id, rentalService_id, pickup_date, first_name, last_name, id_number, gender, birth_year, birth_month, birth_day, driver_license_authority_number, area_code, phone, email, country, address, emergency_contacter, emergency_contact_area_code, emergency_contact, sign_url_base64, idempotency_key) {

            // let _token = await APIS.GET.getCSRFTokenApi();

            try {
                const formData = new FormData();
                formData.append('car_id', car_id);
                formData.append('stronghold_id', stronghold_id);
                formData.append('rental_period_id', rental_period_id);
                formData.append('rentalService_id', rentalService_id);
                formData.append('pickup_date', pickup_date);
                formData.append('first_name', first_name);
                formData.append('last_name', last_name);
                formData.append('id_number', id_number);
                formData.append('gender', gender);
                formData.append('birth_year', birth_year);
                formData.append('birth_month', birth_month);
                formData.append('birth_day', birth_day);
                formData.append('area_code', area_code);
                formData.append('phone', phone);
                formData.append('email', email);
                formData.append('country', country);
                formData.append('address', address);
                formData.append('emergency_contacter', emergency_contacter);
                formData.append('emergency_contact_area_code', emergency_contact_area_code);
                formData.append('emergency_contact', emergency_contact);
                formData.append('sign_url_base64', sign_url_base64);
                formData.append('idempotency_key', idempotency_key);

                const createSubscriptionCarOrder = await axios.post(`/createSubscriptionCarOrder`, formData, {
                    headers: {
                        'X-CSRF-TOKEN': _token
                    }
                });
                return createSubscriptionCarOrder;
            } catch (error) {
                return error;
            }
        },
        async isOffsiteRental(car_models_id, service_strongholds_id) {
            let _token = await APIS.GET.getCSRFTokenApi();
            try {
                const payload = {
                    csrf_token: _token,
                    car_models_id: car_models_id,
                    service_strongholds_id: service_strongholds_id
                };

                const isOffsiteRental = await axios.post(`/isOffsiteRental`, payload, {
                    headers: {
                        'X-CSRF-TOKEN': _token
                    }
                });
                return isOffsiteRental;
            } catch (error) {
                return error;
            }
        },
        async toggleListingRentalService(_token, id) {
            //             car_id（必填）
            // rental_period_id（必填）
            // rentalService_id（選填）
            // let _token = await APIS.GET.getCSRFTokenApi();
            try {
                const payload = {
                    csrf_token: _token,
                    id: id,
                };

                const toggleListingRentalService = await axios.post(`/admin/imanage/CarSubscription/toggleListing_RentalService`, payload, {
                    headers: {
                        'X-CSRF-TOKEN': _token
                    }
                });
                return toggleListingRentalService;
            } catch (error) {
                return error;
            }
        },
        async toggleListingRentalPeriod(_token, id) {
            //             car_id（必填）
            // rental_period_id（必填）
            // rentalService_id（選填）
            // let _token = await APIS.GET.getCSRFTokenApi();
            try {
                const payload = {
                    csrf_token: _token,
                    id: id,
                };

                const toggleListingRentalPeriod = await axios.post(`/admin/imanage/CarSubscription/toggleListing_RentalPeriod`, payload, {
                    headers: {
                        'X-CSRF-TOKEN': _token
                    }
                });
                return toggleListingRentalPeriod;
            } catch (error) {
                return error;
            }
        },
        async Calculatesubscriptionfare(_token, car_id, rental_period_id, serviceIdArr, lang = 'tw') {
            //             car_id（必填）
            // rental_period_id（必填）
            // rentalService_id（選填）
            // let _token = await APIS.GET.getCSRFTokenApi();
            let arr = [];
            for (let i in serviceIdArr) {
                arr.push(serviceIdArr[i]);
            }
            try {
                const payload = {
                    csrf_token: _token,
                    car_id: car_id,
                    rental_period_id: rental_period_id,
                };

                if (arr.length >= 1) {
                    payload['rentalService_id'] = [...arr];
                }

                const Calculatesubscriptionfare = await axios.post(`/Calculatesubscriptionfare?lang=${lang}`, payload, {
                    headers: {
                        'X-CSRF-TOKEN': _token
                    }
                });
                return Calculatesubscriptionfare;
            } catch (error) {
                return error;
            }
        },
        async carLocationRestriction(_token, id, modelIdArr) {
            // let _token = await APIS.GET.getCSRFTokenApi();
            let arr = [];
            for (let i in modelIdArr) {
                arr.push(modelIdArr[i]);
            }
            try {
                const payload = {
                    csrf_token: _token,
                    id: id,
                    Model_id: [...arr]
                };

                const carLocationRestriction = await axios.post(`/admin/imanage/stronghold/carLocationRestriction`, payload, {
                    headers: {
                        'X-CSRF-TOKEN': _token
                    }
                });
                return carLocationRestriction;
            } catch (error) {
                return error;
            }
        },
        async QueryRequest(_token) {
            // let _token = await APIS.GET.getCSRFTokenApi();
            try {

                const QueryRequest = await axios.post(`/QueryRequest`, {
                    headers: {
                        'X-CSRF-TOKEN': _token
                    }
                });
                return QueryRequest;
            } catch (error) {
                return error;
            }
        },
        async SubscriptionVehicleFeeupdateOrCreate(_token, id, car_id, fee, mileage_fee, deposit, is_new) {
            // let _token = await APIS.GET.getCSRFTokenApi();

            if (is_new == 1) {
                is_new = '1';
            } else if (is_new == 0) {
                is_new = '0';
            }

            try {
                const payload = {
                    ...(id && { id }),
                    ...(car_id && { car_id }),
                    ...(fee && { fee }),
                    ...(mileage_fee && { mileage_fee }),
                    ...(deposit && { deposit }),
                    ...(is_new && { is_new }),
                };

                const SubscriptionVehicleFeeupdateOrCreate = await axios.post(`/admin/imanage/CarSubscription/SubscriptionVehicleFeeupdateOrCreate`, payload, {
                    headers: {
                        'X-CSRF-TOKEN': _token
                    }
                });
                return SubscriptionVehicleFeeupdateOrCreate;
            } catch (error) {
                return error;
            }
        },
        async RentalServiceassociation(_token, car_id, rental_service_id) {
            // let _token = await APIS.GET.getCSRFTokenApi();


            try {
                const payload = {
                    car_id: car_id,
                    rental_service_id: [...rental_service_id]
                };

                const RentalServiceassociation = await axios.post(`/admin/imanage/CarSubscription/RentalServiceassociation`, payload, {
                    headers: {
                        'X-CSRF-TOKEN': _token
                    }
                });
                return RentalServiceassociation;
            } catch (error) {
                return error;
            }
        },
        async RentalPeriodassociation(_token, car_id, rental_period_id) {
            // let _token = await APIS.GET.getCSRFTokenApi();


            try {
                const payload = {
                    car_id: car_id,
                    rental_period_id: [...rental_period_id]
                };

                const RentalPeriodassociation = await axios.post(`/admin/imanage/CarSubscription/RentalPeriodassociation`, payload, {
                    headers: {
                        'X-CSRF-TOKEN': _token
                    }
                });
                return RentalPeriodassociation;
            } catch (error) {
                return error;
            }
        },
        async getSubscriptionVehicle(_token, page, pag, ServiceStronghold_id, car_models_id, fee_min, fee_max, is_new, brands, production_time, fee_orderBy
            , production_time_orderBy, County_id, type_id) {
            // let _token = await APIS.GET.getCSRFTokenApi();

            if (is_new != '') {
                if (is_new == 1) {
                    is_new = '1';
                } else if (is_new == 0) {
                    is_new = '0';
                }
            }

            try {
                const payload = {
                    pag: pag,
                    ...(ServiceStronghold_id && { ServiceStronghold_id }),
                    ...(car_models_id && { car_models_id }),
                    ...(fee_min && { fee_min }),
                    ...(fee_max && { fee_max }),
                    ...(is_new && { is_new }),
                    ...(brands && { brands }),
                    ...(production_time && { production_time }),
                    ...(fee_orderBy && { fee_orderBy }),
                    ...(production_time_orderBy && { production_time_orderBy }),
                    ...(County_id && { County_id }),
                    ...(type_id && { type_id }),
                };

                const getSubscriptionVehicle = await axios.post(`/getSubscriptionVehicle?page=${page}`, payload, {
                    headers: {
                        'X-CSRF-TOKEN': _token
                    }
                });
                return getSubscriptionVehicle;
            } catch (error) {
                return error;
            }
        },
        async getSubscriptionVehicleMore(_token, page, pag, ServiceStronghold_id, car_models_id, fee_min, fee_max, is_new, brands, production_time, fee_orderBy
            , production_time_orderBy, County_id, type_id) {
            // let _token = await APIS.GET.getCSRFTokenApi();

            if (is_new != '') {
                if (is_new == 1) {
                    is_new = '1';
                } else if (is_new == 0) {
                    is_new = '0';
                }
            }

            try {
                const payload = {
                    pag: pag,
                    ...(ServiceStronghold_id && { ServiceStronghold_id }),
                    ...(car_models_id && { car_models_id }),
                    ...(fee_min && { fee_min }),
                    ...(fee_max && { fee_max }),
                    ...(is_new && { is_new }),
                    ...(brands && { brands }),
                    ...(production_time && { production_time }),
                    ...(fee_orderBy && { fee_orderBy }),
                    ...(production_time_orderBy && { production_time_orderBy }),
                    ...(County_id && { County_id }),
                    ...(type_id && { type_id }),
                };

                const getSubscriptionVehicle = await axios.post(`/admin/imanage/CarSubscription/getSubscriptionVehicle?page=${page}`, payload, {
                    headers: {
                        'X-CSRF-TOKEN': _token
                    }
                });
                return getSubscriptionVehicle;
            } catch (error) {
                return error;
            }
        },

        async getBackemdSubscriptionVehicle(_token, page, pag, ServiceStronghold_id, car_models_id, fee_min, fee_max, is_new, brands, production_time, fee_orderBy
            , production_time_orderBy) {
            // let _token = await APIS.GET.getCSRFTokenApi();

            if (is_new != '') {
                if (is_new == 1) {
                    is_new = '1';
                } else if (is_new == 0) {
                    is_new = '0';
                }
            }

            try {
                const payload = {
                    pag: pag,
                    ...(ServiceStronghold_id && { ServiceStronghold_id }),
                    ...(car_models_id && { car_models_id }),
                    ...(fee_min && { fee_min }),
                    ...(fee_max && { fee_max }),
                    ...(is_new && { is_new }),
                    ...(brands && { brands }),
                    ...(production_time && { production_time }),
                    ...(fee_orderBy && { fee_orderBy }),
                    ...(production_time_orderBy && { production_time_orderBy }),
                };

                const getSubscriptionVehicle = await axios.post(`/admin/imanage/CarSubscription/getBackemdSubscriptionVehicle?page=${page}`, payload, {
                    headers: {
                        'X-CSRF-TOKEN': _token
                    }
                });
                return getSubscriptionVehicle;
            } catch (error) {
                return error;
            }
        },
        async getBackendSubscriptionGroupVehicle(_token, page, pag, id, car_models_id, fee_min, fee_max, is_new, brands, production_time, fee_orderBy
            , production_time_orderBy) {
            // let _token = await APIS.GET.getCSRFTokenApi();

            if (is_new != '') {
                if (is_new == 1) {
                    is_new = '1';
                } else if (is_new == 0) {
                    is_new = '0';
                }
            }

            try {
                const payload = {
                    pag: pag,
                    ...(id && { id }),
                    ...(car_models_id && { car_models_id }),
                    ...(fee_min && { fee_min }),
                    ...(fee_max && { fee_max }),
                    ...(is_new && { is_new }),
                    ...(brands && { brands }),
                    ...(production_time && { production_time }),
                    ...(fee_orderBy && { fee_orderBy }),
                    ...(production_time_orderBy && { production_time_orderBy }),
                };

                const getBackendSubscriptionGroupVehicle = await axios.post(`/admin/imanage/CarSubscription/getBackendSubscriptionGroupVehicle?page=${page}`, payload, {
                    headers: {
                        'X-CSRF-TOKEN': _token
                    }
                });
                return getBackendSubscriptionGroupVehicle;
            } catch (error) {
                return error;
            }
        },
        async getsubscribedstronghold(_token, page, pag) {
            // let _token = await APIS.GET.getCSRFTokenApi();

            try {
                const payload = {
                    pag: pag || 10
                };

                const getsubscribedstronghold = await axios.post(`/getsubscribedstronghold?page=${page}`, payload, {
                    headers: {
                        'X-CSRF-TOKEN': _token
                    }
                });
                return getsubscribedstronghold;
            } catch (error) {
                return error;
            }
        },
        async getsubscribedOrderstronghold(_token, page, pag) {
            // let _token = await APIS.GET.getCSRFTokenApi();

            try {
                const payload = {
                    pag: pag || 10
                };

                const getsubscribedOrderstronghold = await axios.post(`/getsubscribedOrderstronghold?page=${page}`, payload, {
                    headers: {
                        'X-CSRF-TOKEN': _token
                    }
                });
                return getsubscribedOrderstronghold;
            } catch (error) {
                return error;
            }
        },
        async getGroup(_token, page, pag) {
            // let _token = await APIS.GET.getCSRFTokenApi();

            try {
                const payload = {
                    pag: pag || 10
                };

                const getGroup = await axios.post(`/stronghold/getGroup?page=${page}`, payload, {
                    headers: {
                        'X-CSRF-TOKEN': _token
                    }
                });
                return getGroup;
            } catch (error) {
                return error;
            }
        },
        async RentalServiceupdateOrCreate(_token, id, name, price) {
            // let _token = await APIS.GET.getCSRFTokenApi();

            try {
                const payload = {
                    ...(id && { id }),
                    ...(name && { name }),
                    ...(price && { price }),
                };

                const RentalServiceupdateOrCreate = await axios.post(`/admin/imanage/CarSubscription/RentalServiceupdateOrCreate`, payload, {
                    headers: {
                        'X-CSRF-TOKEN': _token
                    }
                });
                return RentalServiceupdateOrCreate;
            } catch (error) {
                return error;
            }
        },
        async RentalServicelist(_token, page, pag = 10) {
            // let _token = await APIS.GET.getCSRFTokenApi();

            try {
                const payload = {
                    pag: pag,
                };

                const RentalServicelist = await axios.post(`/admin/imanage/CarSubscription/RentalServicelist?page=${page}`, payload, {
                    headers: {
                        'X-CSRF-TOKEN': _token
                    }
                });
                return RentalServicelist;
            } catch (error) {
                return error;
            }
        },
        async RentalPeriodupdateOrCreate(_token, id, bonus_mileage, months) {
            // let _token = await APIS.GET.getCSRFTokenApi();

            try {
                const payload = {
                    ...(id && { id }),
                    ...((bonus_mileage === 0 || bonus_mileage) && { bonus_mileage }),
                    ...(months && { months }),
                };

                const RentalPeriodupdateOrCreate = await axios.post(`/admin/imanage/CarSubscription/RentalPeriodupdateOrCreate`, payload, {
                    headers: {
                        'X-CSRF-TOKEN': _token
                    }
                });
                return RentalPeriodupdateOrCreate;
            } catch (error) {
                return error;
            }
        },
        async RentalPeriodlist(_token, months, page, pag = 10) {
            // let _token = await APIS.GET.getCSRFTokenApi();

            try {
                const payload = {
                    pag: pag,
                    ...(months && { months }),
                };

                const RentalPeriodlist = await axios.post(`/admin/imanage/CarSubscription/RentalPeriodlist?page=${page}`, payload, {
                    headers: {
                        'X-CSRF-TOKEN': _token
                    }
                });
                return RentalPeriodlist;
            } catch (error) {
                return error;
            }
        },
        async RentalPeriodlistForSelect(_token) {
            // let _token = await APIS.GET.getCSRFTokenApi();

            try {
                const payload = {
                    pag: 1000,
                };

                const RentalPeriodlistSelect = await axios.post(`/admin/imanage/CarSubscription/RentalPeriodlist`, payload, {
                    headers: {
                        'X-CSRF-TOKEN': _token
                    }
                });
                return RentalPeriodlistSelect;
            } catch (error) {
                return error;
            }
        },
        async typeUpdateInterval(_token, url) {
            // let _token = await APIS.GET.getCSRFTokenApi();
            // 根據給定的類型 ID 和日期範圍更新價格信息。
            // {
            //     "type": [
            //       0
            //     ],
            //     "start": "2024-09-27",
            //     "end": "2024-09-27",
            //     "price_type": "price"
            //   }

            try {
                const payload = {
                    url: url
                };
                const typeUpdateInterval = await axios.post(`/admin/imanage/api/calendar/type_update_interval`, payload, {
                    headers: {
                        'X-CSRF-TOKEN': _token
                    }
                });
                return typeUpdateInterval;
            } catch (error) {
                return error;
            }
        },
        async createShortUrl(_token, url) {
            // let _token = await APIS.GET.getCSRFTokenApi();

            try {
                const payload = {
                    url: url
                };
                const createShortUrl = await axios.post(`/createShortUrl`, payload, {
                    headers: {
                        'X-CSRF-TOKEN': _token
                    }
                });
                return createShortUrl;
            } catch (error) {
                return error;
            }
        },
        async promoCodecalculate(_token, code, pickup_date, return_date, car_amount) {
            // let _token = await APIS.GET.getCSRFTokenApi();

            try {
                const payload = {
                    pickup_date: pickup_date,
                    return_date: return_date,
                    car_amount: car_amount,
                    code: code,
                    csrf_token: _token,
                };
                const membergetPromoCode = await axios.post(`/promoCodecalculate`, payload, {
                    headers: {
                        'X-CSRF-TOKEN': _token
                    }
                });
                return membergetPromoCode;
            } catch (error) {
                return error;
            }
        },
        async webMembergetPromoCode(code, _token) {
            // let _token = await APIS.GET.getCSRFTokenApi();

            try {
                const payload = {
                    code: code,
                    csrf_token: _token,
                };
                const membergetPromoCode = await axios.post(`/membergetPromoCode`, payload, {
                    headers: {
                        'X-CSRF-TOKEN': _token
                    }
                });
                return membergetPromoCode;
            } catch (error) {
                return error;
            }
        },
        async webGetMemberPromoCode() {
            let _token = await APIS.GET.getCSRFTokenApi();

            try {
                const payload = {
                    csrf_token: _token,
                };
                const getMemberPromoCode = await axios.post(`/getMemberPromoCode`, payload, {
                    headers: {
                        'X-CSRF-TOKEN': _token
                    }
                });
                return getMemberPromoCode;
            } catch (error) {
                return error;
            }
        },
        async webPromoCodeList(page, _token) {
            // let _token = await APIS.GET.getCSRFTokenApi();

            try {
                const payload = {
                    csrf_token: _token,
                    pag: 10
                };
                const promoCodeList = await axios.post(`/promoCodelist?page=${page}`, payload, {
                    headers: {
                        'X-CSRF-TOKEN': _token
                    }
                });
                return promoCodeList;
            } catch (error) {
                return error;
            }
        },
        async promoCodeList(page, _token, payloadObj) {
            // _token = await APIS.GET.getCSRFTokenApi();

            try {
                const payload = {
                    csrf_token: _token,
                    name: payloadObj.name,
                    en_name: payloadObj.en_name,
                    code: payloadObj.code,
                    member_id: payloadObj.member_id,
                    car_id: payloadObj.car_id,
                    type_id: payloadObj.type_id,
                    type: payloadObj.type,
                    start_date: payloadObj.start_date_format,
                    end_date: payloadObj.end_date_format,
                    pag: payloadObj.pag,

                };
                const promoCodeList = await axios.post(`/admin/imanage/promo-code/list?page=${page}`, payload, {
                    headers: {
                        'X-CSRF-TOKEN': _token
                    }
                });
                return promoCodeList;
            } catch (error) {
                return error;
            }
        },
        async promoCodeUpdateOrCreate(_token, payloadObj, id) {
            // 0. 折扣優惠券 1. 固定金額優惠券 2. 會員專屬優惠券 3. 特定車輛專用優惠券 4. 五人 六七人 機車 專用優惠券
            // 0 (X car_id type_id price member_id
            // 1 (X car_id type_id percent member_id
            // 2 (X car_id type_id member_id
            // 4 (X car_id  member_id
            //以上是不用填的內容 之後可能會再填寫資訊


            try {

                const payload = {
                    csrf_token: _token,
                    name: payloadObj.name,
                    en_name: payloadObj.en_name,
                    code: payloadObj.code,
                    type: payloadObj.type,
                    is_visible: payloadObj.is_visible,
                    start_date: payloadObj.start_date_format,
                    end_date: payloadObj.end_date_format,
                    percent: payloadObj.percent,
                    lower_limit: payloadObj.lower_limit,
                    upper_limit: payloadObj.upper_limit,
                    limit: payloadObj.limit,
                    status: payloadObj.status
                };

                if (id != undefined) {
                    payload['id'] = id;
                }

                const promoCodeUpdateOrCreate = await axios.post(`/admin/imanage/promo-code/updateOrCreate`, payload, {
                    headers: {
                        'X-CSRF-TOKEN': _token
                    }
                });
                return promoCodeUpdateOrCreate;
            } catch (error) {
                return error;
            }
        },
        async promoCodeUpdateStatus(_token, status, id) {

            // _token = await APIS.GET.getCSRFTokenApi();

            try {
                const payload = {
                    csrf_token: _token,
                    id: id,
                    status: status
                };
                const promoCodeUpdateStatus = await axios.post(`/admin/imanage/promo-code/updateOrCreate`, payload, {
                    headers: {
                        'X-CSRF-TOKEN': _token
                    }
                });
                return promoCodeUpdateStatus;
            } catch (error) {
                return error;
            }
        },
        async webGetstronghold(id) {

            try {

                let csrf = await APIS.GET.getCSRFTokenApi();

                const payload = {
                    csrf_token: csrf,
                    id: id,

                };
                const getstrongholdRes = await axios.post("/getstronghold", payload);
                // 回傳 200 代表有權限
                return getstrongholdRes;
            } catch (err) {
                // 錯誤即代表沒有權限
                console.log(err)
            }
        },
        async Modelassociation(csrf, modelIdArr, id) {
            try {

                // let csrf = await APIS.GET.getCSRFTokenApi();
                let modelId = [...modelIdArr];

                const payload = {
                    Model_id: modelId,
                    csrf_token: csrf,
                    id: id,

                };
                const ModelassociationRes = await axios.post("/admin/imanage/stronghold/Modelassociation", payload);
                // 回傳 200 代表有權限
                return ModelassociationRes;
            } catch (err) {
                // 錯誤即代表沒有權限
                console.log(err)
            }
        },
        async getstronghold(csrf, id) {
            try {

                // let csrf = await APIS.GET.getCSRFTokenApi();

                const payload = {
                    csrf_token: csrf,
                    id: id
                };
                const getstrongholdRes = await axios.post("/admin/imanage/stronghold/getstronghold", payload);
                // 回傳 200 代表有權限
                return getstrongholdRes;
            } catch (err) {
                // 錯誤即代表沒有權限
                console.log(err)
            }
        },
        async getPermissionVerification(csrf) {
            try {

                // let csrf = await APIS.GET.getCSRFTokenApi();

                const payload = {
                    csrf: csrf,
                };
                const permissionVerificationRes = await axios.post("/admin/imanage/Permission/PermissionVerification", payload);
                // 回傳 200 代表有權限
                return permissionVerificationRes;
            } catch (err) {
                // 錯誤即代表沒有權限
                console.log(err)
            }
        },
        async getOrderSchedule(stronghold, start_date, end_date, csrf) {
            try {

                let csrf = await APIS.GET.getCSRFTokenApi();

                const payload = {
                    CSRF: csrf,
                    stronghold: stronghold,
                    start_date: start_date,
                    end_date: end_date
                };

                const getOrderSchedule = await axios.post('/admin/imanage/home/getOrder_schedule', payload);

                return getOrderSchedule;
            } catch (error) {
                alert('獲取行事曆失敗');
                return error;
            }
        },
        async getOrderRevenue(csrf, stronghold_id, start_date, end_date) {
            try {

                // let csrf = await APIS.GET.getCSRFTokenApi();

                const payload = {
                    CSRF: csrf,
                    stronghold_id: stronghold_id,
                    start_date: start_date,
                    end_date: end_date
                };

                const getOrderRevenue = await axios.post('/admin/imanage/home/getOrderRevenue', payload, {
                    headers: {
                        'X-CSRF-TOKEN': csrf
                    }
                });

                return getOrderRevenue;
            } catch (error) {
                alert('獲取行事曆失敗');
                return error;
            }
        },
        async ticketExcelDetails(files, csrf) {
            try {
                // let csrf = await APIS.GET.getCSRFTokenApi();

                const formData = new FormData();
                formData.append('excel_file[]', files[0]);
                formData.append('csrf', csrf);

                const ticketExcelDetails = await axios.post('/admin/imanage/traffic_ticket/TicketExcelDetails', formData);

                return ticketExcelDetails;
            } catch (error) {
                alert('上傳excel失敗');
                console.log(error);
            }
        },
        async autoLogin(id_number, password, csrf) {
            try {
                // let csrf = await APIS.GET.getCSRFTokenApi();

                const payload = {
                    CSRF: csrf,
                    id_number: id_number,
                    password: password
                };

                const loginResult = await axios.post('/member/API_login', payload);

                return loginResult;
            } catch (error) {
                alert('登入失敗');
                return error;
            }
        },
        async imgUpload(csrf) {

            // let csrf = await APIS.GET.getCSRFTokenApi();

            try {
                const formData = new FormData();
                formData.append('file[]', files[0]);
                formData.append('csrf', csrf);
                const imgUpload = await axios.post('/api/img_upload', formData);
                return imgUpload;
            } catch (error) {
                return error;
            }
        },
        async getMemberSelfOrder(paramas) {
            return await axios.post('/api/getMemberSelfOrder')
                .then(async (res) => {
                    return res;
                })
                .catch((error) => {
                    return error;
                })
        },
        async GetSelfServiceFeeupdate(paramas) {
            return await axios.post('/admin/imanage/SelfService/GetSelfServiceFeeupdate', paramas)
                .then(async (res) => {
                    return res;
                })
                .catch((error) => {
                    return error;
                })
        },
        async GetSelfServiceFee(paramas) {
            return await axios.post('/admin/imanage/SelfService/GetSelfServiceFee')
                .then(async (res) => {
                    return res;
                })
                .catch((error) => {
                    return error;
                })
        },
        async idNumberGetMenber(paramas) {
            try {
                const payload = { id_number: paramas };
                const id_numberGetMenber = await axios.post('/api/id_numberGetMenber', payload);
                return id_numberGetMenber;
            } catch (error) {
                return error;
            }

        },
        async getChatnotify(type, page, CSRF, userId) {
            // 取得對話紀錄

            // type: s:登入者權限 / g:客人
            // user_id:未登入需帶uid

            // let CSRF = await APIS.GET.getCSRFTokenApi();

            try {
                const payload = { CSRF: CSRF, page: page, type: type, };

                if (userId != undefined) {
                    payload.user_id = userId;
                }

                const getChatnotifyRes = await axios.post('/admin/imanage/stronghold/getChatnotify', payload);

                return getChatnotifyRes;

            } catch (error) {
                return error;
            }

        },
        async getChatnotifyGuest(type, page, userId, csrf) {
            // 取得對話紀錄

            // type: s:登入者權限 / g:客人
            // user_id:未登入需帶uid
            let CSRF = '';

            if (csrf == undefined) {
                CSRF = await APIS.GET.getCSRFTokenApi();
            } else {
                CSRF = csrf;
            }

            try {
                const payload = { CSRF: CSRF, page: page, type: type, };

                if (userId != undefined) {
                    payload.user_id = userId;
                }

                const getChatnotifyGuestRes = await axios.post('/getChatnotify', payload);

                return getChatnotifyGuestRes;

            } catch (error) {
                return error;
            }

        },
        async liffLogin(line_id, CSRF) {
            CSRF = await APIS.GET.getCSRFTokenApi();

            try {
                const payload = { line_id: line_id, CSRF: CSRF };
                const liffLogin = await axios.post('/line/member/liff_login', payload);
                return liffLogin;
            } catch (error) {
                return error;
            }

        },
        async liffBinding(line_id, CSRF, id_number, password) {
            CSRF = await APIS.GET.getCSRFTokenApi();

            try {
                const payload = { line_id: line_id, CSRF: CSRF, id_number: id_number, password: password };
                const liffBinding = await axios.post('/line/member/liff_binding', payload);
                return liffBinding;
            } catch (error) {
                return error;
            }

        },
        //忘記密碼寄信給用戶
        async passwordSend(_token, email) {
            try {
                const payload = { _token: _token, email: email };
                const passwordSend = await axios.post('/api/new/password/send', payload);
                return passwordSend;
            } catch (error) {
                return error;
            }

        },
        async getContractNumber(_token) {
            _token = await APIS.GET.getCSRFTokenApi();
            try {
                const payload = { csrf: _token };
                const getContractNumber = await axios.post('/admin/imanage/stronghold/getContractNumber', payload);
                return getContractNumber;
            } catch (error) {
                return error;
            }

        },
        async getReturnUrl(_token, random_id) {
            _token = await APIS.GET.getCSRFTokenApi();
            try {
                const payload = { csrf: _token, random_id: random_id, };
                const getReturnUrl = await axios.post('/returnUrl', payload, {
                    headers: {
                        'Authorization': `Bearer ${_token}`,
                        'X-CSRF-TOKEN': _token
                    }
                });
                return getReturnUrl;
            } catch (error) {
                return error;
            }

        },
        async getOrder(_token, id) {
            _token = await APIS.GET.getCSRFTokenApi();
            try {
                const payload = { csrf: _token, id: id, };
                const getOrder = await axios.post('/admin/imanage/order/getorder', payload, {
                    headers: {
                        'X-CSRF-TOKEN': _token
                    }
                });
                return getOrder;
            } catch (error) {
                return error;
            }

        },
        async contractNumberList(_token) {
            _token = await APIS.GET.getCSRFTokenApi();

            try {
                const payload = { csrf: _token };
                const contractNumberList = await axios.post('/admin/imanage/ContractNumber/list', payload, {
                    headers: {
                        'X-CSRF-TOKEN': _token
                    }
                });
                return contractNumberList;
            } catch (error) {
                return error;
            }
        },
        async customerFeedbackGetList(page, _token, status) {
            _token = await APIS.GET.getCSRFTokenApi();

            try {
                const payload = { csrf: _token, status: status };
                const customerFeedbackGetList = await axios.post(`/admin/imanage/customer_feedback/getList?page=${page}`, payload, {
                    headers: {
                        'X-CSRF-TOKEN': _token
                    }
                });
                return customerFeedbackGetList;
            } catch (error) {
                return error;
            }
        },
        async customerFeedbackSendMail(id, msg, _token) {
            _token = await APIS.GET.getCSRFTokenApi();

            try {
                const payload = { csrf: _token, id: id, msg: msg };
                const customerFeedbackSendMail = await axios.post(`/admin/imanage/customer_feedback/send_mail`, payload, {
                    headers: {
                        'X-CSRF-TOKEN': _token
                    }
                });
                return customerFeedbackSendMail;
            } catch (error) {
                return error;
            }
        },
        async debtCollection(id, amount, details, _token) {
            //             "id": 訂單ID
            //             "details": 品項
            //             "amount": 價錢
            //             "details":款項原由 目前只有etc
            //                 ************* 再請求連結後增加ID ************

            // ### Request[POST]

            //                 + Request

            //         {
            //             "id": "1412",
            //                 "details": '車輛租車輛租金:80,里程費:80,',
            //                     "amount": '1',
            // }
            _token = await APIS.GET.getCSRFTokenApi();

            try {
                const payload = { csrf: _token, id: id, amount: amount, details: details };
                const debtCollection = await axios.post(`/admin/imanage/order/DebtCollection`, payload, {
                    headers: {
                        'X-CSRF-TOKEN': _token
                    }
                });
                return debtCollection;
            } catch (error) {
                throw error;
            }
        },
        async contractNumberCreateOrUpdate(contract_numberst, number = null, id = null, _token) {
            _token = await APIS.GET.getCSRFTokenApi();

            try {
                const payload = {
                    contract_numberst: contract_numberst,
                    csrf: _token
                }

                //如果沒有帶id就是新建合約編號
                if (id != null) {
                    payload['id'] = id;
                }

                //如果沒有帶id就是新建合約編號
                if (number != null) {
                    payload['number'] = number;
                }

                const contractNumberCreateOrUpdate = await axios.post('/admin/imanage/ContractNumber/createOrUpdate', payload, {
                    headers: {
                        'X-CSRF-TOKEN': _token
                    }
                });
                return contractNumberCreateOrUpdate;
            } catch (error) {

                Swal.fire({
                    title: `程式異常請聯繫工程人員`,
                    icon: 'error',
                    confirmButtonColor: '#3085d6',
                    confirmButtonText: '確定',
                })

                return error;
            }
        },
        async getStrongHoldPersonID(csrf) {
            // let csrf = await APIS.GET.getCSRFTokenApi(); 可能之後會解結
            try {
                const payload = { csrf: csrf };
                const getuserIDRes = await axios.post('/admin/imanage/auth/getuserID', payload);
                return getuserIDRes;
            } catch (error) {
                console.log("無法獲取目前使用者id，請重新整理頁面或聯絡客服人員，謝謝您。")
                return error;
            }

        },
        async ManualTrafficViolationScraping(csrf) {
            // let csrf = await APIS.GET.getCSRFTokenApi(); 可能之後會解結
            try {
                const payload = { csrf: csrf };
                const ManualTrafficViolationScrapingRes = await axios.post('/ManualTrafficViolationScraping', payload);
                return ManualTrafficViolationScrapingRes;
            } catch (error) {
                console.log("無法獲取目前使用者id，請重新整理頁面或聯絡客服人員，謝謝您。")
                return error;
            }

        },
        async shortUrlRedirect(ramdon_id) {
            let csrf = await APIS.GET.getCSRFTokenApi();
            try {
                const payload = { csrf: csrf, ramdon_id: ramdon_id };
                const shortUrlRedirect = await axios.post(`/returnUrl`, payload);
                return shortUrlRedirect;
            } catch (error) {
                console.log("shortUrlRedirect程式問題，請重新整理頁面或聯絡客服人員，謝謝您。")
                return error;
            }

        },
        async PermissionVerification(_token) {
            try {
                const payload = { csrf: _token };
                const PermissionVerification = await axios.post(`/admin/imanage/Permission/PermissionVerification`, payload, {
                    headers: {
                        'X-CSRF-TOKEN': _token
                    }
                });
                return PermissionVerification;
            } catch (error) {
                console.log("shortUrlRedirect程式問題，請重新整理頁面或聯絡客服人員，謝謝您。")
                return error;
            }

        },
        async getBannerList(payload, _token) {
            try {
                const res = await axios.post(`/admin/imanage/banner/getBanner`, payload, {
                    headers: {
                        'X-CSRF-TOKEN': _token
                    }
                });
                return res;
            } catch (error) {
                throw error;
            }
        },
        async updateBanner(payload, _token) {
            try {
                const res = await axios.post(`/admin/imanage/banner/home/sort/update`, payload, {
                    headers: {
                        'X-CSRF-TOKEN': _token
                    }
                });
                return res;
            } catch (error) {
                throw error;
            }
        },
        async getVehicleRevenue(payload, _token) {
            try {
                const res = await axios.post(`/admin/imanage/car/api/getVehicleRevenue`, payload, {
                    headers: {
                        'X-CSRF-TOKEN': _token
                    }
                });
                return res;
            } catch (error) {
                throw error;
            }
        },
        async createLineGroup(payload, _token) {
            try {
                const res = await axios.post(`/admin/imanage/stronghold/line-group-store`, payload, {
                    headers: {
                        'X-CSRF-TOKEN': _token
                    }
                });
                return res;
            } catch (error) {
                throw error;
            }
        }
    },
    GET: {
        async salesmanCommissionList(promo_code,start_date,end_date,status,order_number,page,perPage = 10) {
            try {
                const params = {
                    page,
                    perPage
                };
                // 有值才加進去
                if (promo_code != null) params.promo_code = promo_code;
                if (start_date != null) params.start_date = start_date;
                if (end_date != null) params.end_date = end_date;
                if (status != null) params.status = status;
                if (order_number != null) params.order_number = order_number;

                const res = await axios.get(
                    '/admin/imanage/salesman/commission/list',
                    { params }
                );
                return res;
            } catch (error) {
                alert('salesmanCommissionList 異常，請重新整理頁面或聯絡客服人員');
                throw error;
            }
        },
        async salesman() {
            try {
                const salesman = await axios.get(`/admin/imanage/salesman/show`);
                return salesman;
            } catch (error) {
                alert("/admin/imanage/salesman/show異常，請重新整理頁面或聯絡客服人員，謝謝您。")
                throw error;
            }
        },
        async getAllianceMileagePointRateByAllianceId(alliance_id) {
            try {
                const getAllianceMileagePointRateByAllianceId = await axios.get(`/admin/imanage/cooperation/getAllianceMileagePointRateByAllianceId?alliance_id=${alliance_id}`);
                return getAllianceMileagePointRateByAllianceId;
            } catch (error) {
                alert("/admin/imanage/cooperation/getAllianceMileagePointRateByAllianceId異常，請重新整理頁面或聯絡客服人員，謝謝您。")
                throw error;
            }
        },
        async getFeaturesByAllianceName(name) {
            try {
                const getFeaturesByAllianceName = await axios.get(`/allianceFeatures/getFeaturesByAllianceName?name=${name}`);
                return getFeaturesByAllianceName;
            } catch (error) {
                // alert("/allianceFeatures/getFeaturesByAllianceName")
                throw error;
            }
        },

        async getFeaturesByAllianceId(alliance_id) {
            try {
                const getFeaturesByAllianceId = await axios.get(`/admin/imanage/cooperation/allianceFeatures/getFeaturesByAllianceId?alliance_id=${alliance_id}`);
                return getFeaturesByAllianceId;
            } catch (error) {
                alert("/admin/imanage/cooperation/allianceFeatures/getFeaturesByAllianceId異常，請重新整理頁面或聯絡客服人員，謝謝您。")
                throw error;
            }
        },
        async getFeaturesByAllianceName(name) {
            try {
                const getFeaturesByAllianceName = await axios.get(`/allianceFeatures/getFeaturesByAllianceName?name=${name}`);
                return getFeaturesByAllianceName;
            } catch (error) {
                // alert("/allianceFeatures/getFeaturesByAllianceName異常，請重新整理頁面或聯絡客服人員，謝謝您。")
                throw error;
            }
        },
        async insuranceCompanyList(page, pag = 10, payload = {}) {
            try {
                let url = `/admin/imanage/car/insurance-company/list?page=${page}&perPage=${pag}`;
                Object.entries(payload).forEach(([key, value]) => {
                    if (value !== undefined && value !== null && value !== '') {
                        url += `&${key}=${encodeURIComponent(value)}`;
                    }
                });
                const response = await axios.get(url);
                return response;
            } catch (error) {
                alert("/admin/imanage/car/insurance-company/list 異常，請重新整理頁面或聯絡客服人員，謝謝您。");
                return error;
            }
        },
        async gettAlliancePointAndBatch(alliances_id, type, points) {
            try {
                const gettAlliancePointAndBatch = await axios.get(`/admin/imanage/cooperation/gettAlliancePointAndBatch?alliances_id=${alliances_id}&type=${type}&points=${points}`);
                return gettAlliancePointAndBatch;
            } catch (error) {
                alert("/admin/imanage/cooperation/gettAlliancePointAndBatch異常，請重新整理頁面或聯絡客服人員，謝謝您。")
                throw error;
            }
        },
        async getAlliancePointHistory(per_page=10, page, members_id, alliances_id ) {
            try {
                const getAlliancePointHistory = await axios.get(`/member/getAlliancePointHistory?per_page=${per_page}&page=${page}&members_id=${members_id}&alliances_id=${alliances_id }`, );
                return getAlliancePointHistory;
            } catch (error) {
                throw error;
            }
        },
        async getAlliancePointByAllianceId(alliances_id) {
            try {
                const getAlliancePointByAllianceId = await axios.get(`/admin/imanage/cooperation/getAlliancePointByAllianceId?alliances_id=${alliances_id}`);
                return getAlliancePointByAllianceId;
            } catch (error) {
                alert("/admin/imanage/cooperation/getAlliancePointByAllianceId異常，請重新整理頁面或聯絡客服人員，謝謝您。")
                throw error;
            }
        },
        async getMemberAllPoints(members_id) {
            try {
                const getMemberAllPoints = await axios.get(`/member/getMemberAllPoints?members_id=${members_id}`, );
                return getMemberAllPoints;
            } catch (error) {
                throw error;
            }
        },
        async getMemberTicket(page, pag = 10,) {
            try {
                const getMemberTicket = await axios.get(`/FlexibleRental/getMemberTicket?page=${page}&pag=${pag}`);
                return getMemberTicket;
            } catch (error) {
                alert("/FlexibleRental/getMemberTicket異常，請重新整理頁面或聯絡客服人員，謝謝您。")
                return error;
            }
        },
        async getAllianceConditionUserPoint(page, per_page = 10, payload = {}) {
            try {
                let url = `/admin/imanage/cooperation/getAllianceConditionUserPoint?page=${page}&per_page=${per_page}`;
                Object.entries(payload).forEach(([key, value]) => {
                    if (value !== undefined && value !== null && value !== '') {
                        url += `&${key}=${encodeURIComponent(value)}`;
                    }
                });
                const response = await axios.get(url);
                return response;
            } catch (error) {
                alert("/admin/imanage/cooperation/getAllianceConditionUserPoint 異常，請重新整理頁面或聯絡客服人員，謝謝您。");
                return error;
            }
        },
        async flexibleRentalPurchaseLog(member_flexible_rental_tickets) {
            try {
                const flexibleRentalPurchaseLog = await axios.get(`/FlexibleRental/flexibleRentalPurchaseLog?member_flexible_rental_tickets=${member_flexible_rental_tickets}`, );
                return flexibleRentalPurchaseLog;
            } catch (error) {
                throw error;
            }
        },
        async flexibleRentalPurchaseLogUrl(payload) {
            try {
                const flexibleRentalPurchaseLogUrl = await axios.get(`/FlexibleRental/flexibleRentalPurchaseLogUrl?buyer_email=${payload.email}&buyer_phone=${payload.phone}`, );
                return flexibleRentalPurchaseLogUrl;
            } catch (error) {
                throw error;
            }
        },
        async flexibleRentalYicketsLog(page, pag = 10, payload = {}) {
            try {
                let url = `/admin/imanage/FlexibleRental/flexibleRentalYicketsLog?page=${page}&pag=${pag}`;
                Object.entries(payload).forEach(([key, value]) => {
                    if (value !== undefined && value !== null && value !== '') {
                        url += `&${key}=${encodeURIComponent(value)}`;
                    }
                });
                const response = await axios.get(url);
                return response;
            } catch (error) {
                alert("/admin/imanage/FlexibleRental/flexibleRentalYicketsLog 異常，請重新整理頁面或聯絡客服人員，謝謝您。");
                return error;
            }
        },

        async getMember() {
            try {
                const getMember = await axios.get(`/member/getMember`);
                return getMember;
            } catch (error) {
                alert("/member/getMember異常，請重新整理頁面或聯絡客服人員，謝謝您。")
                return error;
            }
        },
        async getUpcomingCalendar(date) {
            try {
                const getUpcomingCalendar = await axios.get(`/Calendar/getUpcomingCalendar?date=${date}`);
                return getUpcomingCalendar;
            } catch (error) {
                alert("/Calendar/getUpcomingCalendar異常，請重新整理頁面或聯絡客服人員，謝謝您。")
                return error;
            }
        },
        async getServiceStrongholdProductsAndBusinessHours(service_strongholds_id ) {
            try {
                const getServiceStrongholdProductsAndBusinessHours = await axios.get(`/Stronghold/getServiceStrongholdProductsAndBusinessHours?service_strongholds_id=${service_strongholds_id }`);
                return getServiceStrongholdProductsAndBusinessHours;
            } catch (error) {
                alert("/Stronghold/getServiceStrongholdProductsAndBusinessHours異常，請重新整理頁面或聯絡客服人員，謝謝您。")
                return error;
            }
        },
        async getFrontFlexibleRentalList(page, per_page = 10) {
            try {
                const getFrontFlexibleRentalList = await axios.get(`/FlexibleRental/getFrontFlexibleRentalList?page=${page}&per_page=${per_page}`);
                return getFrontFlexibleRentalList;
            } catch (error) {
                alert("/FlexibleRental/getFrontFlexibleRentalList異常，請重新整理頁面或聯絡客服人員，謝謝您。")
                return error;
            }
        },

        async getCtbcMerchantFlexibleRental() {
            try {
                const getCtbcMerchantFlexibleRental = await axios.get(`/admin/imanage/FlexibleRental/getCtbcMerchantFlexibleRental`);
                return getCtbcMerchantFlexibleRental;
            } catch (error) {
                alert("/admin/imanage/FlexibleRental/getCtbcMerchantFlexibleRental異常，請重新整理頁面或聯絡客服人員，謝謝您。")
                return error;
            }

        },
        async getTemplates(page, pag = 10, stronghold_id) {
            try {
                if (stronghold_id) {
                    const getTemplates = await axios.get(`/admin/imanage/sms/getTemplates?page=${page}&pag=${pag}&stronghold_id=${stronghold_id}`);
                    return getTemplates;
                } else {
                    const getTemplates = await axios.get(`/admin/imanage/sms/getTemplates?page=${page}&pag=${pag}`);
                    return getTemplates;
                }
            } catch (error) {
                alert("/admin/imanage/sms/getTemplates異常，請重新整理頁面或聯絡客服人員，謝謝您。")
                return error;
            }

        },
        async exportCarReport() {
            try {
                const exportCarReport = await axios.get(`/admin/imanage/car/exportCarReport`);
                return exportCarReport;
            } catch (error) {
                alert("/admin/imanage/car/exportCarReport異常，請重新整理頁面或聯絡客服人員，謝謝您。")
                return error;
            }

        },
        async throttleLog(pag) {
            try {
                const throttleLog = await axios.get(`/admin/imanage/throttle_log?page=${pag}`);
                return throttleLog;
            } catch (error) {
                alert("/admin/imanage/throttle_log異常，請重新整理頁面或聯絡客服人員，謝謝您。")
                return error;
            }

        },
        async stronghold_details(stronghold, car_model, start_date, start_time, end_date, end_time) {
            try {
                const stronghold_details = await axios.get(`/stronghold/TaipeiCity/details?stronghold_type=stronghold&stronghold=${stronghold}&car_model=${car_model}&start_date=${start_date}&start_time=${start_time}&end_date=${end_date}&end_time=${end_time}`);
                return stronghold_details;
            } catch (error) {
                alert("/stronghold/TaipeiCity/details異常，請重新整理頁面或聯絡客服人員，謝謝您。")
                return error;
            }

        },
        async rate_description() {
            try {
                const rate_description = await axios.get('/admin/imanage/integral/rate_description');
                return rate_description;
            } catch (error) {
                alert("/admin/imanage/integral/rate_description異常，請重新整理頁面或聯絡客服人員，謝謝您。")
                return error;
            }

        },
        async selfService_all_fee() {
            try {
                const selfService_all_fee = await axios.get('/selfService_all_fee');
                return selfService_all_fee;
            } catch (error) {
                alert("/all-fee異常，請重新整理頁面或聯絡客服人員，謝謝您。")
                return error;
            }

        },
        async car_model_id(car_model) {
            try {
                const car_model_id = await axios.get(`/api/type/get/with/car_model_id?car_model=${car_model}`);
                return car_model_id;
            } catch (error) {
                console.log("取得車種異常請重新整理或聯繫工程人員，謝謝您。")
                return error;
            }

        },
        async county() {
            try {
                const county = await axios.get('/admin/imanage/api/county');
                return county;
            } catch (error) {
                console.log("/admin/imanage/api/county異常，請重新整理頁面或聯絡客服人員，謝謝您。")
                return error;
            }

        },
        async countyWeb() {
            try {
                const county = await axios.get('/api/county');
                return county;
            } catch (error) {
                console.log("/api/county異常，請重新整理頁面或聯絡客服人員，謝謝您。")
                return error;
            }

        },
        async StrongholdPermissions() {

            try {
                const StrongholdPermissions = await axios.get(`/StrongholdPermissions`);
                return StrongholdPermissions;
            } catch (error) {
                console.log("無法獲取目前登入者資料，請重新整理頁面或聯絡客服人員，謝謝您。");
                return error;
            }

        },
        async getMemberInfo(stronghold, year, month, category) {
            // 可能之後會解結
            // 訂單行事曆

            // stronghold = 據點
            // year = 年
            // month = 月
            // category = 車款 //若無則是全部

            try {
                const getMemberInfo = await axios.get(`/api/get_Member_Login_Status_And_Info`);
                return getMemberInfo;
            } catch (error) {
                console.log("無法獲取目前登入者資料，請重新整理頁面或聯絡客服人員，謝謝您。")
                return error;
            }

        },
        async orderCalendarapi(stronghold, year, month, category) {
            // 可能之後會解結
            // 訂單行事曆

            // stronghold = 據點
            // year = 年
            // month = 月
            // category = 車款 //若無則是全部

            try {
                const orderCalendarapi = await axios.get(`/admin/imanage/calendar/orderCalendarapi?stronghold=${stronghold}&year=${year}&month=${month}&category=${category}`);
                return orderCalendarapi;
            } catch (error) {
                console.log("無法獲取目前使用者id，請重新整理頁面或聯絡客服人員，謝謝您。")
                return error;
            }

        },
        async getMemberStatus() {
            try {
                const response = await axios.get('/api/get_Member_status');
                return response.data;
            } catch (error) {
                console.log("取得登入資訊異常，請重新整理頁面或聯絡客服人員，謝謝您。")
                return error;
            }

        },
        async getServiceStronghold() {
            try {
                const response = await axios.get('/admin/imanage/api/getServiceStronghold');
                return response.data;
            } catch (error) {
                console.log("取得登入權限異常，請重新整理頁面或聯絡客服人員，謝謝您。")
                return error;
            }

        },
        async getMemberLoginStatusAndInfo() {
            try {
                const memberLoginStatusAndInfoRes = await axios.get('/api/get_Member_Login_Status_And_Info');
                return memberLoginStatusAndInfoRes;
            } catch (error) {
                console.log("取得登入資訊異常，請重新整理頁面或聯絡客服人員，謝謝您。")
                return error;
            }

        },

        async getGoodcarsLocation() {

            try {
                const response = await axios.get(`/api/Get_Goodcars_location`);
                return response.data;
            } catch (error) {
                console.log("取得自助據點資訊異常，請重新整理頁面或聯絡客服人員，謝謝您。")
                return error;
            }
        },
        async getStrongholdControl() {
            try {
                const getStrongholdControl = await axios.get('/admin/imanage/order/api/get_stronghold_control');
                return getStrongholdControl;
            } catch (error) {
                console.log(`/admin/im anage/order/api/get_stronghold_control程式錯誤 請聯繫工作人員`);
                return error;
            }

        },
        async makepdfApi(oid) {
            try {
                const makepdfApi = await axios.get('/api/makepdf_api?oid=' + oid);
                return makepdfApi;
            } catch (error) {
                console.log(`/api/makepdf_api程式錯誤 請聯繫工作人員`);
                return error;
            }

        },
        async getlist() {
            // 20240318--HL判斷複製綠界連結出現或者隱藏
            //獲得初始金流資料
            try {
                const getlist = await axios.get('/api/Cashflow/getlist');
                return getlist;
            } catch (error) {
                console.log(`/api/Cashflow/getlist程式錯誤 請聯繫工作人員`);
                return error;
            }

        },
        async getarea() {
            try {
                const getarea = await axios.get('/api/getarea');
                return getarea;
            } catch (error) {
                console.log(`/api/getarea程式錯誤 請聯繫工作人員`);
                return error;
            }
        },
        async getCSRFTokenApi() {
            try {
                const getCSRF = await axios.get('/csrf-token')
                return getCSRF.data.csrf_token
            } catch (err) {
                console.log('取得CSRFToken失敗，請聯繫管理人員。')
                return error;
            }
        },
        async logout() {
            try {
                const resLogout = await axios.get('/member/logout');
                return 'success';
            } catch (error) {
                console.log(`/member/logout程式錯誤 請聯繫工作人員`);
                return error;
            }
        },
        async api_logout() {
            try {
                const resApiLogout = await axios.get('/member/api_logout');
                return 'success';
            } catch (error) {
                console.log(`/member/api_logout程式錯誤 請聯繫工作人員`);
                return error;
            }
        }

    },
    DELETE: {
        async deleteDiscount(id) {
            try {
                const deleteDiscount = await axios.delete(`/admin/imanage/discount-info/${id}/delete`);
                return deleteDiscount;
            } catch (error) {
                console.log(`/admin/imanage/discount-info/{id}/delete程式錯誤 請聯繫工作人員`);
                return error;
            }
        },
        async deleteBanner(payload, _token) {
            try {
                const res = await axios.delete(`/admin/imanage/banner/home/delete`, {
                    headers: {
                        'X-CSRF-TOKEN': _token
                    },
                    data: payload
                });
                return res;
            } catch (error) {
                throw error;
            }
        },
        async deleteCarInsurance(id) {
            try {
                const response = await axios.delete(`/admin/imanage/car/insurance/${id}`);
                return response;
            } catch (error) {
                alert("/admin/imanage/car/insurance/{id}異常，請重新整理頁面或聯絡客服人員，謝謝您。")
                return error;
            }
        },
        async deleteCarCoverageInsurance(id) {
            try {
                const response = await axios.delete(`/admin/imanage/car/coverage-insurance/${id}`);
                return response;
            } catch (error) {
                alert("/admin/imanage/car/coverage-insurance/{id}異常，請重新整理頁面或聯絡客服人員，謝謝您。")
                return error;
            }
        },
        async deleteCarInspection(id) {
            try {
                const response = await axios.delete(`/admin/imanage/car/inspection/${id}`);
                return response;
            } catch (error) {
                alert("/admin/imanage/car/inspection/{id}異常，請重新整理頁面或聯絡客服人員，謝謝您。")
                return error;
            }
        }
    },
    PUT: {}
}

